<template>
    <div class="m-0">
        <CCol sm="12" style="width: 100%;background-size: cover; margin: auto;color: #fff">
            <CCard class="bg-white b-20 m-3 p-20 mb-5" style="border:none;">
                <div class="p-3">
                    <h3 class="custom-32px-500 text-left font-color-171717">Setting</h3>
    
                    <CTabs variant="pills" class="custom-tabs1">
                        <CTab title="My Profile" active>
    
                            <CRow class="mt-3">
                                <CCol sm="2" class="text-left">
                                    <div class="avatar-container text-left">
                                        <!-- <img src="../assets/img/avatar.png" class="avatar-img" style="max-width:100px" />
                                                                                                                            <img src="../assets/img/edit.png" class="edit-img" style="max-width:30px" /> -->
    
    
                                        <img v-if="filePath == ''" width="100px" src="../assets/img/DefaultUser.png" class="avatar-img" />
                                        <img v-else width="100px" :src="filePath" style="border-radius: 50%; border: 5px solid #fff" class="avatar-img" />
                                        <img src="../assets/img/edit.png" class="edit-img" style="max-width:30px" @click="triggerFileInput" />
                                        <input type="file" ref="fileInput" @change="onFileChange" style="display: none;" id="Q1" />
                                    </div>
                                </CCol>
                                <CCol sm="10">
                                    <h4 class="custom-18px-500 font-color-171717 mt-2">{{ FullName }}</h4>
                                    <p class="custom-14px-400 font-color-687588 mt-2">{{ UserType }}</p>
                                </CCol>
                                <CCol sm="12" class="m-2">
                                    <CCard class="border-16px">
                                        <div class="m-3">
                                            <h3 class="custom-16px-500 font-color-171717 text-left">
                                                Subscription
                                            </h3>
                                            <hr />
                                            <CRow>
                                                <CCol sm="3">
                                                    <h4 class="custom-14px-400 font-inter font-color-687588">Account type</h4>
                                                </CCol>
                                                <CCol sm="7">
                                                    <h4 class="custom-16px-600 font-inter font-color-687588">
                                                        {{ details.Subscriptions }}
                                                    </h4>
                                                </CCol>
                                                <CCol sm="2">
                                                    <CButton class="custom-border-purple p-2 text-left mr-2 text-white" @click="GoToPlanCompany()">Add Credit</CButton>
                                                </CCol>
    
                                                <CCol sm="3">
                                                    <h4 class="custom-14px-400 font-inter font-color-687588">Credit has been used</h4>
                                                </CCol>
                                                <CCol sm="9">
                                                    <h4 class="custom-14px-400 font-inter font-color-171717">
                                                        {{ details.CreditUse }} Candidates</h4>
    
    
                                                </CCol>
    
                                                <CCol sm="3" class="mt-2">
                                                    <h4 class="custom-14px-400 font-inter font-color-687588">Credit available</h4>
                                                </CCol>
                                                <CCol sm="9" class="mt-2">
                                                    <h4 class="custom-14px-400 font-inter font-color-171717"> {{ details.CreditAvailable }} Candidates</h4>
                                                </CCol>
                                            </CRow>
                                        </div>
                                    </CCard>
                                </CCol>
                                <CCol sm="12">
                                    <h3 class="custom-16px-500 font-color-171717 mt-2 text-left">
                                        Personal Information
                                    </h3>
                                </CCol>
                                <CCol sm="6">
                                    <label class="custom-14px-400 font-color-687588">
                                        Account Type
                                    </label>
                                    <CInput type="text" v-model="UserType" disabled id="Q2" />
                                </CCol>
                                <CCol sm="6"> 
                                    <label class="custom-14px-400 font-color-687588">
                                        Name Of Company
                                     </label>
                                    <CInput type="text" v-model="FullName" id="Q3" />
                                </CCol>
                                <CCol sm="6">
                                    <label class="custom-14px-400 font-color-687588">
                                        Email Company
                                    </label>
                                    <CInput type="text" v-model="Email" disabled id="Q4" />
                                </CCol>
                                <CCol sm="6"> 
                                    <label class="custom-14px-400 font-color-687588">
                                        Phone Number
                                    </label>
                                    <CInput type="text" v-model="PhoneNumber" id="Q5" />
                                </CCol>
                                <CCol sm="12" class="mb-3">
                                    <label class="label-custom-header-subtitle mt-3">Country</label>
                                    <v-select v-model="SelectedCountry" :options="country" label="CountryName"></v-select>
                                </CCol>
                            </CRow>
    
                            <CCard class="bg-F7F7F7-plain b-20" style="border:none;background-color: #f7f7f7;">
                                <CRow class="m-3">
                                </CRow>
                                <CCol sm="12">
                                    <CRow>
                                        <CCol sm="6"></CCol>
                                        <CCol sm="6">
                                            <div class="d-flex justify-content-end text-right">
                                                <label class="p-2 mr-5 text-danger" style="width:130px">Delete Account</label>
                                                <label class="custom-border-purple p-2 mr-2 text-white text-center" style="width:130px" @click="UpdateProfile">Save</label>
                                            </div>
                                        </CCol>
                                    </CRow>
                                </CCol>
                                </CRow>
                            </CCard>
                        </CTab>
                        <CTab title="Security">
                            <CRow class="mt-2">
    
                                <CCol sm="12">
                                    <h3 class="custom-16px-500 font-color-171717 mt-2 text-left">
                                        Change Password
                                    </h3>
                                    <label class="custom-14px-400 font-color-687588">
                                                                                                                                Old Password
                                                                                                                            </label>
                                    <CInput type="password" v-model="currentPassword" />
                                </CCol>
    
                                <CCol sm="6">
                                    <label class="custom-14px-400 font-color-687588">
                                                                                                                                    New Password
                                                                                                                                </label>
                                    <CInput type="password" v-model="password" @input="password_check" />
                                </CCol>
                                <CCol sm="6">
                                    <label class="custom-14px-400 font-color-687588">
                                                                                                                                    Email
                                                                                                                                </label>
                                    <CInput type="text" :value="Email" disabled/>
                                </CCol>
                                <CCol sm="12" class="font-color-171717">
                                    <h3 class="custom-16px-500 font-color-171717 mt-2 text-left">
                                        Password Requirements:
                                    </h3>
                                    <p class="frmValidation" :class="{'frmValidation--passed' : password.length > 7}">
                                        <img v-if="password.length > 7" src="../assets/img/checked.png" style="width:20px" />
                                        <img v-else src="../assets/img/unchecked.png" alt="Unchecked" class="frmIcon" style="width:20px" /> A minimum of 8 character
    
                                    </p>
                                    <p class="frmValidation" :class="{'frmValidation--passed' :has_uppercase }">
                                        <img v-if="has_uppercase" src="../assets/img/checked.png" style="width:20px" />
                                        <img v-else src="../assets/img/unchecked.png" style="width:20px" /> At least one uppercase character
                                    </p>
    
                                    <p class="frmValidation" :class="{'frmValidation--passed' : has_lowercase }">
                                        <img v-if="has_lowercase" src="../assets/img/checked.png" style="width:20px" />
                                        <img v-else src="../assets/img/unchecked.png" style="width:20px" /> At least one lowercase character
                                    </p>
                                    <p class="frmValidation" :class="{'frmValidation--passed' : has_number }">
                                        <img v-if="has_number" src="../assets/img/checked.png" style="width:20px" />
                                        <img v-else src="../assets/img/unchecked.png" style="width:20px" /> At least one numeric character
                                    </p>
                                    <p class="frmValidation" :class="{'frmValidation--passed' : has_special }">
                                        <img v-if="has_special" src="../assets/img/checked.png" style="width:20px" />
                                        <img v-else src="../assets/img/unchecked.png" style="width:20px" /> At least one symbol character
                                    </p>
                                </CCol>
                                <CCol sm="12">
                                    <CRow>
                                        <CCol sm="6"></CCol>
                                        <CCol sm="6">
                                            <div class="d-flex justify-content-end text-right">
                                                <label class="custom-border-purple p-2 mr-2 text-white text-center" style="width:130px" @click="ChangePassword">Save</label>
                                            </div>
                                        </CCol>
                                    </CRow>
                                </CCol>
                            </CRow>
                        </CTab>
                        <CTab title="Subscribe">
                            <CCol sm="12" :style="colStyle">
                            <div class="text-center mt-5">
    
                                <h3 class="custom-32px-500 text-center font-color-171717"><span class="custom-32px-600">Company</span> Subscription </h3>
                                <p class="custom-16px-400">Our AI-powered platform offers top-notch feedback, along with exclusive <br /> insights from industry experts.</p>
                            </div>
                            <div class="">
                                <CRow class="" style="display: flex; flex-wrap: wrap;">
    
                                    <CCol sm="6" style="flex: 1 0 50%;" v-for="item in packages" v-bind:key="item.packageId">
                                        <CCard class="b-20 bg-FAFAFA">
                                            <h3 class="custom-24px-500 text-center mt-3">
                                                {{ item.packageName }}
                                            </h3>
                                            <span class="text-center"><label class="custom-48px-500 font-color-171717">$ {{ item.packagePrice }}</label><label v-for="items,index in item.PackageDetails" v-bind:key="items.packageDetailId"> <div v-if="index == 0">/ {{ items.Type }}</div></label></span>
                                            <p class="custom-16px-400 text-center font-color-171717" style="width:70%;margin:0 auto">{{ item.packageDescription }}</p>
                                            <hr class="custom-hr m-4" />
                                            <div>
                                                <ul style="width:80%" v-for="items in item.PackageDetails" v-bind:key="items.packageDetailId" class="font-color-171717">
                                                    <li style="text-align: left;">{{ items.Description }}</li>
                                                </ul>
                                            </div>
    
                                            <div class="text-center m-0 mb-5 mt-4">
                                                <span class="custom-border-purple p-2 text-white text-center" @click="GoToConfirmation(item.packagePrice, item.packageId)">Subscribe</span>
                                            </div>
                                        </CCard>
                                    </CCol>
    
    
    
                                </CRow>
                            </div>
                            </CCol>
    
    
                        </CTab>
                        <CTab title="FAQ">
                            <CCol sm="12">
                                <h3 class="custom-16px-500 font-color-171717 mt-5 text-left">
                                    Supported Payment Methods
                                </h3>
                                <p class="custom-14px-400 font-color-687588">Payment methods that are available with one of Vuexy's approved payment providers.</p>
                            </CCol>
                            <div style="text-align: left;" class="{ activeclass: isActive }">
                                <ToggleCard title="1. How do I access the candidate video interview dashboard?">
                                    Interviewrr.ai is a state-of-the-art AI-powered platform designed to help job seekers improve their interview skills through automated question generation and video interviews. Users receive feedback from industry experts and AI algorithms to refine their
                                    skills and resumes.
    
                                </ToggleCard>
    
                                <ToggleCard title="2. What information does the candidate video interview dashboard provide?">
                                    Users record their answers to automatically generated questions via their device and submit the video on our platform. Our advanced AI analyzes the video and voice to identify user characteristics and how closely their answers align with those suggested
                                    by experts. It categorizes responses into individual user profiles, accessible only by the user or potential employers. In addition to AI analysis, we partner with other companies to review each candidate and offer feedback
                                    through our system. Following submission, they receive expert feedback and tailored advice to help enhance their interview performance.
                                </ToggleCard>
    
                                <ToggleCard title="3. Can I track interviewer performance through the dashboard?">
                                    Interviewrr.ai offers two free practice sessions for all users. If you wish to continue using the platform beyond these sessions, a minimal fee will apply for additional usage.
                                </ToggleCard>
    
                                <ToggleCard title="4. Can companies view my video interviews?">
                                    Yes, with your consent, companies searching for new employees can view your video interviews. You will be asked whether you wish to make your videos accessible to potential employers after submitting your last video.</ToggleCard>
    
                                <ToggleCard title="5. How can companies access candidate videos?">
                                    Companies can access videos of candidates based on the specific job categories they are interested in. Access is dependent on the type of package they have purchased, which determines how many and which videos they can view.
    
                                </ToggleCard>
    
                                <ToggleCard title="6. How does Interviewrr.ai ensure fairness and accuracy in feedback?">
                                    Our AI algorithms are designed to objectively assess candidates' skills and qualifications, complemented by insights from industry experts. This dual approach helps eliminate bias and improve the accuracy of the feedback provided.
                                </ToggleCard>
    
                                <ToggleCard title="7. What can I do if I need more than two practice sessions?">
                                    If you need additional practice beyond the free sessions, you can easily continue using Interviewrr.ai by paying a minimal fee for each subsequent session. This allows you to further hone your skills at a reasonable cost. The price can be viewed at plan
                                    page. these preferences on your settings page, ensuring a comfortable and secure interaction.</ToggleCard>
    
    
                            </div>
                        </CTab>
                        <CTab title="Customize Questions">
                            <h1 class="custom-18px-600 mt-3 ml-3">
                                Customize Questions for Candidate
                            </h1>
                            <div v-if="ShowList === true">
                                <div class="text-right mb-3">
                                    <CButton type="button" class="custom-border-purple text-white ml-3" @click="toggleAddQuestion">
                                        <span class="ml-3 mr-3">{{ buttonQuestion }}</span>
                                    </CButton>
                                </div>
                                <CRow>
                                    <CCol sm="10">
                                        <CInput type="text" placeholder="Search..." v-model="searchQuery" @keyup.enter="filterList" id="Q6" />
                                    </CCol>
                                    <CCol sm="2" style="margin:0px auto">
                                        <select v-model="itemsPerPage" id="itemsPerPage" class="form-control">
                                      <option value="10">Show 10</option>
                                      <option value="20">Show 20</option>
                                      <option value="50">Show 50</option>
                                    </select>
                                    </CCol>
                                </CRow>
                                <CDataTable hover class="table-align-middle mb-0 font-color-171717" :items="filteredList" :fields="fields" :items-per-page="itemsPerPage" :pagination="true">
                                    <template #Specifications="{ item }">
                                        <td>
                                            <label class="custom-12px-500 ml-2">{{ item.job }}</label>
                                        </td>
                                    </template>

                                    <template #Amount="{ item }">
                                        <td>
                                            {{ item.totalQuestion }}
                                        </td>
                                    </template>

                                    <template #Code="{ item }">
                                        <td>
                                            {{ item.code }}
                                        </td>
                                    </template>

                                    <template #ValidUntill="{ item }">
                                        <td>
                                            {{ item.validDate }}
                                        </td>
                                    </template>

                                    <template #Objective="{ item }">
                                        <td>
                                            <div class="objective-container">
                                                <label class="custom-border-purple p-20 b-20 text-white" @click="toggleObjective(item)">
                                                                                        <span class="mr-3 ml-3">View</span>
                                                                                        </label>
                                                <div v-if="isObjectiveVisible(item)" class="objective-popup">
                                                    {{ item.objective || 'No record objective...' }}
                                                </div>
                                            </div>
                                        </td>
                                    </template>

                                    <template #Action="{ item }">
                                        <td>
                                            <label class="custom-border-purple p-20 b-20 text-white" @click="OpenUpdate(item.Id, item.job, item.positionCode)"><span class="mr-3 ml-3">Edit</span></label>
                                            <img src="../assets/img/delete.png" @click="OpenDelete(item.Id, item.job)" style="max-width:30px" class="ml-2">
                                        </td>
                                    </template>
                                </CDataTable>
                            </div>
                            <div v-if="isUpdateQuestion" class="font-color-171717">
                                <div class="text-right mb-3">
                                    <CButton type="button" class="custom-border-purple text-white ml-3" @click="toggleUpdateQuestion">
                                        <span class="ml-3 mr-3">Back To Home</span>
                                    </CButton>
                                </div>
                                    <div class="m-2">
                                    <h4 class="custom-14px-400 font-color-696969">
                                        Career field for the interview
                                    </h4>

                                    <div class="tabs ml-1">
                                        <span @click="setActiveTabCode('QG')" :class="{ active: activeTabCode === 'QG', disabled: !isTabEnabledCode('QG') }">General Question</span>
                                        <span> > </span>
                                        <span @click="setActiveTabCode('QT')" :class="{ active: activeTabCode === 'QT', disabled: !isTabEnabledCode('QT') }">Technical Question</span>
                                        <span> > </span>
                                        <span @click="setActiveTabCode('QB')" :class="{ active: activeTabCode === 'QB', disabled: !isTabEnabledCode('QB') }">Behaviour Question</span>
                                        <span> > </span>
                                        <span @click="setActiveTabCode('QS')" :class="{ active: activeTabCode === 'QS', disabled: !isTabEnabledCode('QS') }">Stress Question</span>
                                        <span> > </span>
                                        <span @click="setActiveTabCode('QA')" :class="{ active: activeTabCode === 'QA', disabled: !isTabEnabledCode('QA') }">Assessment Question</span>
                                        <span> > </span>
                                        <span @click="setActiveTabCode('code')" :class="{ active: activeTabCode === 'code', disabled: !isTabEnabledCode('code') }">Copy Code</span>
                                        </div>
                                        <!-- <v-select :value="jobValue"></v-select> -->
                                        <v-select 
  v-model="jobValue" 
  :options="positionOptions" 
  label="Name" 
  :reduce="job => job.Id">
</v-select>

                                            <div v-if="activeTabCode === 'QG'">
                                                
                                            <div v-for="(item,index) in generalQuestionsCode" :key="item.questionId" class="m-2">
                                                <div class="text-right">
                                                    <label class="font-color-171717 text-right" style="text-align:right" @click="OpenCloneCode('QG', jobCode, index, item.companyQuestionId)">
                                                        <img src="../assets/img/Plus.png" style="max-width:20px" class="mr-2" @click="OpenCloneCode('QG', jobCode, index, item.companyQuestionId)"/> Clone
                                                    </label>
                                                </div>
                                                <CCard class="b-20 bg-FAFAFA m-3">
                                                <div class="m-3">
                                                    <h4 class="custom-14px-400 font-color-696969">Question</h4>
                                                    <CInput type="text" v-model="item.question" id="Q7"/>
                                                    <h4 class="custom-14px-400 font-color-696969">Answer</h4>
                                                    <CTextarea type="text" rows="3" v-model="item.answer" />
                                                    <h4 class="custom-14px-400 font-color-696969">Max Timer</h4>
                                                        <v-timepicker
                                                            v-model="item.MaxTimeLimit"
                                                            :options="timer"
                                                            format="HH:mm:ss"
                                                            :minute-interval="1"
                                                            placeholder="Insert Duration"
                                                            @input="formatTimerMax(item)"
                                                        ></v-timepicker>
                                                        <br /> <br />
                                                    <img src="../assets/img/delete.png" @click="DeleteQuestionCode(item)" style="max-width: 30px;" class="cursor-pointer mr-1" />
                                                    <span class="text-danger cursor-pointer" @click="DeleteQuestionCode(item)">Delete question</span>

                                                    <span>
                                                        <CButton type="button" class="custom-border-purple-928AFD font-color-615FCD ml-3" @click="UpdateQuestionFirst('QG', item.companyQuestionId, item.question, item.answer, index,item.MinTimeLimit, item.MaxTimeLimit)">Save Question</CButton>
                                                    </span>
                                                    <br /><br />
                                                    <CAlert color="danger" v-if="errorMessages[index]">{{ errorMessages[index] }}</CAlert>
                                                </div>
                                                </CCard>
                                            </div>
                                            <div class="ml-3">
                                                <CButton type="button" class="custom-border-purple-928AFD font-color-615FCD ml-3" style="border-radius:5px" @click="addQuestionCode('QG')">Add Question</CButton>
                                            </div>
                                            </div>

                                    <div v-if="activeTabCode === 'QT'">
                                    <div v-for="(item, index) in technicalQuestionsCode" :key="item.questionId" class="m-2">
                                        <div class="text-right">
                                            <label class="font-color-171717 text-right" style="text-align:right" @click="OpenCloneCode('QT', jobCode, index, item.companyQuestionId)">
                                                                <img src="../assets/img/Plus.png" style="max-width:20px" class="mr-2" @click="OpenCloneCode('QT', jobCode, index, item.companyQuestionId)"/> Clone
                                                            </label>
                                        </div>
                                        <CCard class="b-20 bg-FAFAFA m-3">
                                        <div class="m-3">
                                            <h4 class="custom-14px-400 font-color-696969">Question</h4>
                                            <CInput type="text" v-model="item.question" />
                                            <h4 class="custom-14px-400 font-color-696969">Answer</h4>
                                            <CTextarea type="text" rows="3" v-model="item.answer" />
                                            <h4 class="custom-14px-400 font-color-696969">Max Timer</h4>
                                                <v-timepicker
                                                        v-model="item.MaxTimeLimit"
                                                        :options="timer"
                                                        format="HH:mm:ss"
                                                        :minute-interval="1"
                                                        placeholder="Insert Duration"
                                                        @input="formatTimerMax(item)"
                                                        >
                                                        </v-timepicker>
                                                        <br /> <br />
                                            <img src="../assets/img/delete.png" @click="DeleteQuestionCode(item)" style="max-width: 30px;" class="cursor-pointer mr-1" />
                                            <span class="text-danger cursor-pointer" @click="DeleteQuestionCode(item)">Delete question</span>

                                            <span>
                                                <CButton type="button" class="custom-border-purple-928AFD font-color-615FCD ml-3" @click="UpdateQuestion('QT', item.companyQuestionId, item.question, item.answer, 'other',index,item.MinTimeLimit, item.MaxTimeLimit)">Save Question</CButton>
                                            </span>
                                            <br /><br />
                                            <CAlert color="danger" v-if="technicalErrorMessages[index]">{{ technicalErrorMessages[index] }}</CAlert>
                                        </div>
                                        </CCard>
                                    
                                    </div>
                                    <div class="ml-3">
                                        <CButton type="button" class="custom-border-purple-928AFD font-color-615FCD ml-3" style="border-radius:5px" @click="addQuestionCode('QT')">Add Question</CButton>
                                    </div>
                                    </div>

                                    <div v-if="activeTabCode === 'QB'">
                                    <div v-for="(item, index) in behaviourQuestionsCode" :key="item.questionId" class="m-2">
                                        <div class="text-right">
                                                                            <label class="font-color-171717 text-right" style="text-align:right" @click="OpenCloneCode('QB', jobCode, index, item.companyQuestionId)">
                                                                                                <img src="../assets/img/Plus.png" style="max-width:20px" class="mr-2" @click="OpenCloneCode('QB', jobCode, index, item.companyQuestionId)"/> Clone
                                                                                            </label>
                                                                        </div>
                                        <CCard class="b-20 bg-FAFAFA m-3">
                                        <div class="m-3">
                                            <h4 class="custom-14px-400 font-color-696969">Question</h4>
                                            <CInput type="text" v-model="item.question" />
                                            <h4 class="custom-14px-400 font-color-696969">Answer</h4>
                                            <CTextarea type="text" rows="3" v-model="item.answer" />
                                            <h4 class="custom-14px-400 font-color-696969">Max Timer</h4>
                                            <v-timepicker
                                                        v-model="item.MaxTimeLimit"
                                                        :options="timer"
                                                        format="HH:mm:ss"
                                                        :minute-interval="1"
                                                        placeholder="Insert Duration"
                                                        @input="formatTimerMax(item)"
                                                        >
                                                        </v-timepicker>
                                                        <br /> <br />
                                            <img src="../assets/img/delete.png" @click="DeleteQuestionCode(item)" style="max-width: 30px;" class="cursor-pointer mr-1" />
                                            <span class="text-danger cursor-pointer" @click="DeleteQuestionCode(item)">Delete question</span>

                                            <span>
                                                <CButton type="button" class="custom-border-purple-928AFD font-color-615FCD ml-3" @click="UpdateQuestion('QB', item.companyQuestionId, item.question, item.answer, 'other',index,item.MinTimeLimit, item.MaxTimeLimit)">Save Question</CButton>
                                            </span>
                                            <br /> <br />
                                            <CAlert color="danger" v-if="behaviourErrorMessages[index]">{{ behaviourErrorMessages[index] }}</CAlert>
                                        </div>
                                        </CCard>
                                    </div>
                                    <div class="ml-3">
                                        <CButton type="button" class="custom-border-purple-928AFD font-color-615FCD ml-3" style="border-radius:5px" @click="addQuestionCode('QB')">Add Question</CButton>
                                    </div>
                                    </div>

                                    <div v-if="activeTabCode === 'QS'">
                                    <div v-for="(item,index) in stressQuestionsCode" :key="item.questionId" class="m-2">
                                        <div class="text-right">
                                                                            <label class="font-color-171717 text-right" style="text-align:right" @click="OpenCloneCode('QS', jobCode, index, item.companyQuestionId)">
                                                                                                <img src="../assets/img/Plus.png" style="max-width:20px" class="mr-2" @click="OpenCloneCode('QS', jobCode, index, item.companyQuestionId)"/> Clone
                                                                                            </label>
                                                                        </div>
                                        <CCard class="b-20 bg-FAFAFA m-3">
                                        <div class="m-3">
                                            <h4 class="custom-14px-400 font-color-696969">Question</h4>
                                            <CInput type="text" v-model="item.question" />
                                            <h4 class="custom-14px-400 font-color-696969">Answer</h4>
                                            <CTextarea type="text" rows="3" v-model="item.answer" />
                                            <h4 class="custom-14px-400 font-color-696969">Max Timer</h4>
                                                <v-timepicker
                                                        v-model="item.MaxTimeLimit"
                                                        :options="timer"
                                                        format="HH:mm:ss"
                                                        :minute-interval="1"
                                                        placeholder="Insert Duration"
                                                        @input="formatTimerMax(item)"
                                                        >
                                                        </v-timepicker>
                                                        <br /> <br />
                                            <img src="../assets/img/delete.png" @click="DeleteQuestionCode(item)" style="max-width: 30px;" class="cursor-pointer mr-1" />
                                            <span class="text-danger cursor-pointer" @click="DeleteQuestionCode(item)">Delete question</span>

                                            <span>
                                                <CButton type="button" class="custom-border-purple-928AFD font-color-615FCD ml-3" @click="UpdateQuestion('QS', item.companyQuestionId, item.question, item.answer, 'other',index,item.MinTimeLimit, item.MaxTimeLimit)">Save Question</CButton>
                                            </span>
                                            <br /> <br />
                                            <CAlert color="danger" v-if="stressErrorMessages[index]">{{ stressErrorMessages[index] }}</CAlert>
                                        </div>
                                        </CCard>
                                    </div>
                                    <div class="ml-3">
                                        <CButton type="button" class="custom-border-purple-928AFD font-color-615FCD ml-3" style="border-radius:5px" @click="addQuestionCode('QS')">Add Question</CButton>
                                    </div>
                                    </div>

                                    <div v-if="activeTabCode === 'QA'">
                                    <div v-for="(item,index) in assessmentQuestionsCode" :key="item.questionId" class="m-2">
                                        <div class="text-right">
                                                                            <label class="font-color-171717 text-right" style="text-align:right" @click="OpenCloneCode('QA', jobCode, index, item.companyQuestionId)">
                                                                                                <img src="../assets/img/Plus.png" style="max-width:20px" class="mr-2" @click="OpenCloneCode('QA', jobCode, index, item.companyQuestionId)"/> Clone
                                                                                            </label>
                                                                        </div>
                                        <CCard class="b-20 bg-FAFAFA m-3">
                                        <div class="m-3">
                                            <h4 class="custom-14px-400 font-color-696969">Question</h4>
                                            <CInput type="text" v-model="item.question" />
                                            <h4 class="custom-14px-400 font-color-696969">Answer</h4>
                                            <CTextarea type="text" rows="3" v-model="item.answer" />
                                            <h4 class="custom-14px-400 font-color-696969">Max Timer</h4>
                                            <v-timepicker
                                                        v-model="item.MaxTimeLimit"
                                                        :options="timer"
                                                        format="HH:mm:ss"
                                                        :minute-interval="1"
                                                        placeholder="Insert Duration"
                                                        @input="formatTimerMax(item)"
                                                        >
                                                        </v-timepicker>
                                                        <br /> <br />
                                            <img src="../assets/img/delete.png" @click="DeleteQuestionCode(item)" style="max-width: 30px;" class="cursor-pointer mr-1" />
                                            <span class="text-danger cursor-pointer" @click="DeleteQuestionCode(item)">Delete question</span>

                                            <span>
                                                <CButton type="button" class="custom-border-purple-928AFD font-color-615FCD ml-3" @click="UpdateQuestion('QA', item.companyQuestionId, item.question, item.answer, 'other',index,item.MinTimeLimit, item.MaxTimeLimit)">Save Question</CButton>
                                            </span>
                                            <br /> <br />
                                            <CAlert color="danger" v-if="assessementErrorMessages[index]">{{ assessementErrorMessages[index] }}</CAlert>
                                        </div>
                                        </CCard>
                                    </div>
                                    <div class="ml-3">
                                        <CButton type="button" class="custom-border-purple-928AFD font-color-615FCD ml-3" style="border-radius:5px" @click="addQuestionCode('QA')">Add Question</CButton>
                                    </div>
                                    </div>

                                    <div v-if="activeTabCode === 'code'">
                                    <div v-for="item in generalQuestionsCode.slice(0, 1)" :key="item.questionId">
                                        <CRow class="mt-3">
                                                                        <CCol sm="6">
                                                                            <label class="custom-14px-400 font-color-696969">Started Date</label>
                                                                            <CInput type="date" v-model="item.startDate" />
                                                                        </CCol>
                                                                        <CCol sm="6">
                                                                            <label class="custom-14px-400 font-color-696969">Expired Date</label>
                                                                            <CInput type="date" v-model="item.endDate" />
                                                                        </CCol>

                                                                        <CCol sm="6">
                                                                            <label class="custom-14px-400 font-color-696969">Language</label>
                                                                            <!-- <v-select 
                                                                                v-model="item.language" 
                                                                                :options="language" 
                                                                                label="Language"
                                                                            ></v-select> -->

                                                                            <v-select
                                                                                v-model="item.languageId"
                                                                                :options="language"
                                                                                label="Language"
                                                                                :reduce="lang => lang.Id"
                                                                                placeholder="Select a Language"
                                                                            />
                                                                        </CCol>
                                                                        <CCol sm="12">
                                                                            <h4 class="custom-14px-400 font-color-696969 mt-4">Prompt Condition - Please describe what you want the answer focusing about</h4>
                                                                            <CTextarea type="text" rows="3" v-model="item.CustomPrompt" />
                                                                        </CCol>


                                                                        <CCol sm="12" class="mb-4 mt-4">
                                                                            <label class="custom-14px-400 font-color-696969">Select Score Category</label>
                                                                            <div class="custom-purple-928AFD text-white" @click="OpenUpdateCategory()">
                                                                                Select Score Category
                                                                            </div>
                                                                        
                                                                        </CCol>

                                                                        <CCol sm="12" class="mb-2 mt-2" v-if="isAllowEVoucher">
                                                                            <CRow>
                                                                                <CCol sm="9"> <label class="custom-14px-400 font-color-696969">Include e-Voucher</label></CCol>
                                                                                <CCol sm="3">
                                                                                    <div class="text-right">
                                                                                    <CButton @click="openEditVoucher(item.Id)" class="custom-border-purple-white font-color-928AFD">Include e-Voucher</CButton>
                                                                                </div>
                                                                                </CCol>
                                                                            </CRow>
                                                                        </CCol>

                                                                    

                                                                        <CCol sm="12" class="mb-2 mt-2">
                                                                            <CRow>
                                                                                <CCol sm="10">   <label class="custom-14px-400 font-color-696969"><strong>Allow AI report to be emailed</strong></label>
                                                                            <label class="custom-14px-400 font-color-696969">The "Allow AI report to be emailed" option enables users to receive 
                                                                                AI-generated reports directly via email. When a user checks the corresponding checkbox, the system automatically emails the report to the user's registered email address once the report is generated. This feature provides users with the convenience of receiving timely reports without having to manually download or access them from the system.</label></CCol>
                                                                                <CCol sm="2">
                                                                                    <div class="text-right mt-4">
                                                                                        <input type="checkbox" v-model="item.isAllowEmailReport" style="width:30px;height:30px" @change="updateCheckboxValue(item)" />
                                                                                </div>
                                                                                </CCol>
                                                                            </CRow>
                                                                        </CCol>

                                                                        <CCol sm="12" class="mb-2 mt-2">
                                                                            <CRow>
                                                                                <CCol sm="10"> <label class="custom-14px-400 font-color-696969"><strong> Publish Status:</strong></label></CCol>
                                                                                <CCol sm="2">
                                                                                    <div class="text-right"> <input type="checkbox" v-model="item.isPublish" style="width:30px;height:30px"/></div>
                                                                                </CCol>
                                                                            </CRow>
                                                                        </CCol>

                                                                    

                                                                        <CCol sm="12" class="mb-2">
                                                                            <label class="custom-14px-400 font-color-696969">Objective</label>
                                                                            <CTextarea v-model="item.objective" type="text" id="20-1" rows="9"></CTextarea>
                                                                        
                                                                        </CCol>
                                                                    

                                                                        <CCol sm="12">
                                                                            <CCard class="b-20 bg-FAFAFA">
                                                                                <div class="m-3">
                                                                                    <h3 class="custom-16px-500 text-left mb-3">
                                                                                        Share Your Company Code
                                                                                    </h3>
                                                                                    <CRow>
                                                                                        <CCol sm="9">
                                                                                            <CInput type="text" v-model="item.code" />
                                                                                        </CCol>
                                                                                        <CCol sm="3">
                                                                                            <label class="custom-border-purple p-2 text-white" @click="copyCodeAff">
                                                            <img src="../assets/img/copy-white.png" style="max-width:15px" class="mr-2" />
                                                            {{ buttonText }}
                                                        </label>
                                                                                        </CCol>
                                    
                                                                                    </CRow>
                                                                                    <h3 class="custom-16px-500 text-left mb-3">How It Works</h3>
                                                                                    <p class="font-color-696969 custom-16px-500 text-left" style="color:#696969">
                                                                                        <strong class="text-black">1. Share Your Code:</strong> Distribute your unique company code with potential candidates. This code will be used to access the set of customized questions prepared by your
                                                                                        company.
                                                                                        <br /> <br />
                                                                                        <strong class="text-black"> 2. Candidate Access: </strong>When candidates enter your company code during their registration or application process, they will be presented with your company's specific
                                                                                        questions. This ensures that all candidates are evaluated based on the criteria most relevant to your organization.
                                                                                        <br /> <br />
                                                                                        <strong class="text-black">3. Customized Evaluation:</strong> Candidates will answer the customized questions provided by your company. This allows you to assess their suitability more accurately based
                                                                                        on your tailored requirements.
                                                                                    </p>

                                                                                    <div class="text-center mt-3">
                                                                                        <CAlert color="danger" v-if="ErrorEdit === true" class="mt-2">Error : Error to save. Please update the form</CAlert>
                                                                                        <label class="custom-border-purple p-2 mr-5 pl-2 pr-2 text-white" @click="UpdateQuestionCode(item.startDate, item.endDate, item.code, item.Id,item.isPublish, item.objective,item.isAllowEmailReport, item.languageId, item.CustomPrompt)">Save Changes</label>
                                                                                    </div>
                                    
                                                                                </div>
                                    
                                                                            </CCard>
                                    
                                                                        </CCol>
                                    
                                                                    </CRow>
                                    </div>
                                    </div>
                                </div>
                            </div> 
                            <div v-if="isAddQuestion">
                                <div class="text-right mb-3">
                                <CButton type="button" class="custom-border-purple text-white ml-3" @click="toggleAddQuestion">
                                    <span class="ml-3 mr-3">{{ buttonQuestion }}</span>
                                </CButton>
                            </div>
                            <p class="custom-14px-400 font-color-696969 ml-3">Companies can categorize their questions to tailor them to specific needs and job roles.</p>
                            <div class="tabs ml-3">
                                
                                <span @click="setActiveTab('general')" :class="{ active: activeTab === 'general', disabled: !isTabEnabled('general') }">General Question</span>
                                <span> > </span>
                                <span @click="setActiveTab('technical')" :class="{ active: activeTab === 'technical', disabled: !isTabEnabled('technical') }">Technical Question</span>
                                <span> > </span>
                                <span @click="setActiveTab('behaviour')" :class="{ active: activeTab === 'behaviour', disabled: !isTabEnabled('behaviour') }">Behaviour Question</span>
                                <span> > </span>
                                <span @click="setActiveTab('stress')" :class="{ active: activeTab === 'stress', disabled: !isTabEnabled('stress') }">Stress Question</span>
                                <span> > </span>
                                <span @click="setActiveTab('assessment')" :class="{ active: activeTab === 'assessment', disabled: !isTabEnabled('assessment') }">Assessment Question</span>
                                <span> > </span>
                                <span @click="setActiveTab('code')" :class="{ active: activeTab === 'code', disabled: !isTabEnabled('code') }">Copy Code</span>
                                
                            </div>
                            <div class="m-4">
                                <CRow>
                                    <CCol sm="10"> <h4 class="custom-14px-400 font-color-696969">
                                    Career field for the interview
                                </h4>
                                <v-select v-model="selectedPosition" :options="positionOptions" label="Name" :disabled="activeTab !== 'general'"></v-select></CCol>
                                    <CCol sm="2">
                                        <h4 class="custom-14px-400 font-color-696969 mt-1">
                                    <strong>OR</strong>
                                </h4>
                                        <CButton type="button" class="custom-border-purple-928AFD font-color-615FCD" style="border-radius:5px"
                                    @click="toggleCustomPositionInput"
                                    >
                                    {{ showCustomInput ? 'Cancel' : ' + Add Custom Field' }}
                                    </CButton>
                                    </CCol>
                                </CRow>
                               
                              

                                    <!-- Custom Position Input -->
                                    <div v-if="showCustomInput" class="custom-position-input">
                                    <CInput 
                                        type="text" 
                                        v-model="customPosition" 
                                        placeholder="Enter custom position" 
                                        class="mt-3"
                                    />
                                    <CButton 
                                        type="button" 
                                        @click="AddCustomPosition" 
                                        class="custom-border-purple-928AFD font-color-615FCD mt-2" style="border-radius:5px"
                                    >
                                        Save Custom Position
                                    </CButton>
                                    <div class="text-center">
                                    <CAlert color="danger" v-if="ErrorPosition === true" class="mt-2"> {{ Message }}</CAlert>
                                </div>
                                </div>

                            </div>
                            <div v-if="activeTab === 'general'">
                                <span class="custom-light-purple font-color-928AFD mb-3 ml-4">
                                    General Questions List
                                </span>
                                <br /><br />
                                <div v-for="(question,index) in questions.general" :key="question.id" class="m-2">
                                    <CCard class="b-20 bg-FAFAFA m-3">
                                        <div class="m-3">
                                            <h3 class="custom-16px-500 text-left font-color-171717">{{ question.indexQuestion }}</h3>
                                            <CRow>
                                                <CCol sm="8">
                                                    <h4 class="custom-14px-400 font-color-696969">You may clone the question from our question bank or create your own question</h4>
                                                </CCol>
                                                <CCol sm="4">
                                                    <div class="text-right mr-3">
                                        <label class="font-color-171717 text-right" style="text-align:right" @click="OpenClone('QG', selectedPosition.Code, index)">
                                                            <img src="../assets/img/Plus.png" style="max-width:20px" class="mr-2" @click="OpenClone('QG', selectedPosition.Code, index)"/> Clone
                                                        </label>
                                    </div>
                                                </CCol>
                                                </CRow>
                                            <CInput type="text" v-model="question.answer" id="Q8"/>
                                            <h4 class="custom-14px-400 font-color-696969">Answer</h4>
                                            <CTextarea type="text" rows="3" v-model="question.expectedAnswer" id="Q9"/>
                                            <h4 class="custom-14px-400 font-color-696969">Max Timer</h4>
                                            <v-timepicker
                                            v-model="question.maxTimeLimit"
                                            :options="timer"
                                            format="HH:mm:ss"
                                            :minute-interval="1"
                                            placeholder="Insert Duration"
                                            @input="formatTimerAddMax(item)"
                                            >
                                            </v-timepicker>
                                            <br /><br />
                                            <img src="../assets/img/delete.png" @click="deleteQuestion('general', question.id)" style="max-width: 30px;" class="cursor-pointer" /> <span class="text-danger" @click="deleteQuestion('general', question.id)">Delete question</span>

                                        </div>


                                    </CCard>
                                </div>
                                <div class="ml-3">
                                    <CButton type="button" class="custom-border-purple-928AFD font-color-615FCD ml-3" style="border-radius:5px" @click="addQuestion('general')">Add Question</CButton>
                                </div>
                                <div class="text-center m-3">
                                    <CAlert color="danger" v-if="ErrorGeneral === true" class="mt-2">The "General Question" tab must have at least 2 questions.</CAlert>
                                    <CAlert color="danger" v-if="ErrorGeneralMax === true" class="mt-2">{{ ErrorMessageGeneralMax }}</CAlert>
                                    <CButton type="button" class="custom-border-purple text-white ml-3 b-20" @click="nextTab('general')"><span class="ml-3 mr-3">Next</span></CButton>
                                </div>
                            </div>

                            <div v-if="activeTab === 'technical'">
                                <span class="custom-light-purple font-color-928AFD mb-3 ml-4">
                                    Technical Questions List
                                </span>
                                <br /><br />
                                <div v-for="(question,index) in questions.technical" :key="question.id" class="m-3">
                                    <CCard class="b-20 bg-FAFAFA m-3">
                                    
                                    
                                        <div class="m-3">
                                            <h3 class="custom-16px-500 text-left">{{ question.indexQuestion }}</h3>
                                            <CRow>
                                                <CCol sm="8">
                                                    <h4 class="custom-14px-400 font-color-696969">You may clone the question from our question bank or create your own question</h4>
                                                </CCol>
                                                <CCol sm="4">
                                                    <div class="text-right mr-3">
                                                        <label class="font-color-171717 text-right" style="text-align:right" @click="OpenClone('QT', selectedPosition.Code, index)">
                                                            <img src="../assets/img/Plus.png" style="max-width:20px" class="mr-2" @click="OpenClone('QT', selectedPosition.Code, index)"/> Clone
                                                        </label>
                                                        </div>
                                                </CCol>
                                                </CRow>
                                            <CInput type="text" v-model="question.answer" id="Q10"/>
                                            <h4 class="custom-14px-400 font-color-696969">Answer</h4>
                                            <CTextarea type="text" rows="3" v-model="question.expectedAnswer" id="Q11"/>
                                            <h4 class="custom-14px-400 font-color-696969">Max Timer</h4>
                                            <v-timepicker
                                            v-model="question.maxTimeLimit"
                                            :options="timer"
                                            format="HH:mm:ss"
                                            :minute-interval="1"
                                            placeholder="Insert Duration"
                                            @input="formatTimerAddMax(item)"
                                            >
                                            </v-timepicker>
                                            <br /><br />
                                            <img src="../assets/img/delete.png" @click="deleteQuestion('technical', question.id)" style="max-width:30px" class="ml-3" /> <span class="text-danger" @click="deleteQuestion('technical', question.id)">Delete question</span>
                                        </div>

                                    </CCard>

                                </div>
                                <div class="ml-3">
                                    <CButton type="button" class="custom-border-purple-928AFD font-color-615FCD ml-3" style="border-radius:5px" @click="addQuestion('technical')">Add Question</CButton>
                                </div>
                                <div class="text-center">
                                    <CAlert color="danger" v-if="ErrorOtherMax === true" class="mt-2">{{ ErrorMessageOtherMax }}</CAlert>
                                    <CButton type="button" class="custom-border-purple text-white ml-3 b-20" @click="nextTabOther('technical')"><span class="ml-3 mr-3">Next</span></CButton>
                                </div>
                            </div>

                            <div v-if="activeTab === 'behaviour'">
                                <span class="custom-light-purple font-color-928AFD mb-3 ml-4">
                                    Behaviour Questions List
                                </span>
                                <br /><br />
                                <div v-for="(question,index) in questions.behaviour" :key="question.id" class="m-3">
                                    <CCard class="b-20 bg-FAFAFA m-3">
                                    <div class="text-right">
                                        
                                    </div>
                                    
                                        <div class="m-3">
                                            <h3 class="custom-16px-500 text-left">{{ question.indexQuestion }}</h3>
                                            <CRow>
                                                <CCol sm="8">
                                                    <h4 class="custom-14px-400 font-color-696969">You may clone the question from our question bank or create your own question</h4>
                                                </CCol>
                                                <CCol sm="4">
                                                    <div class="text-right mr-3">
                                                        <label class="font-color-171717 text-right" style="text-align:right" @click="OpenClone('QB', selectedPosition.Code, index)">
                                                            <img src="../assets/img/Plus.png" style="max-width:20px" class="mr-2" @click="OpenClone('QB', selectedPosition.Code, index)"/> Clone
                                                        </label>
                                                        </div>
                                                </CCol>
                                                </CRow>
                                            <CInput type="text" v-model="question.answer" id="Q12"/>
                                            <h4 class="custom-14px-400 font-color-696969">Answer</h4>
                                            <CTextarea type="text" rows="3" v-model="question.expectedAnswer" id="Q13" />
                                            <h4 class="custom-14px-400 font-color-696969">Max Timer</h4>
                                            <v-timepicker
                                            v-model="question.maxTimeLimit"
                                            :options="timer"
                                            format="HH:mm:ss"
                                            :minute-interval="1"
                                            placeholder="Insert Duration"
                                            @input="formatTimerAddMax(item)"
                                            >
                                            </v-timepicker>
                                            <br /><br />
                                            <img src="../assets/img/delete.png" @click="deleteQuestion('behaviour', question.id)" style="max-width:30px" class="ml-3" /> <span class="text-danger" @click="deleteQuestion('behaviour', question.id)">Delete question</span>
                                        </div>
                                    </CCard>
                                </div>
                                <div class="ml-3">
                                    <CButton type="button" class="custom-border-purple-928AFD font-color-615FCD ml-3" style="border-radius:5px" @click="addQuestion('behaviour')">Add Question</CButton>
                                </div>
                                <div class="text-center">
                                    <CAlert color="danger" v-if="ErrorOtherMax === true" class="mt-2">{{ ErrorMessageOtherMax }}</CAlert>
                                    <CButton type="button" class="custom-border-purple text-white ml-3 b-20" @click="nextTabOther('behaviour')"><span class="ml-3 mr-3">Next</span></CButton>
                                </div>
                            </div>

                            <div v-if="activeTab === 'stress'">
                                <span class="custom-light-purple font-color-928AFD mb-3 ml-4">
                                    Stress Questions List
                                </span>
                                <br /><br />
                                <div v-for="(question,index) in questions.stress" :key="question.id" class="m-3">
                                    <CCard class="b-20 bg-FAFAFA m-3">
                                        <div class="m-3">
                                            <h3 class="custom-16px-500 text-left">{{ question.indexQuestion }}</h3>
                                            <CRow>
                                                <CCol sm="8">
                                                    <h4 class="custom-14px-400 font-color-696969">You may clone the question from our question bank or create your own question</h4>
                                                </CCol>
                                                <CCol sm="4">
                                                    <div class="text-right mr-3">
                                                        <label class="font-color-171717 text-right" style="text-align:right" @click="OpenClone('QS', selectedPosition.Code, index)">
                                                            <img src="../assets/img/Plus.png" style="max-width:20px" class="mr-2" @click="OpenClone('QS', selectedPosition.Code, index)"/> Clone
                                                        </label>
                                                        </div>
                                                </CCol>
                                                </CRow>



                                            <CInput type="text" v-model="question.answer" id="Q14"/>
                                            <h4 class="custom-14px-400 font-color-696969">Answer</h4>
                                            <CTextarea type="text" rows="3" v-model="question.expectedAnswer" id="Q15"/>
                                            <h4 class="custom-14px-400 font-color-696969">Max Timer</h4>
                                            <v-timepicker
                                            v-model="question.maxTimeLimit"
                                            :options="timer"
                                            format="HH:mm:ss"
                                            :minute-interval="1"
                                            placeholder="Insert Duration"
                                            @input="formatTimerAddMax(item)"
                                            >
                                            </v-timepicker>
                                            <br /><br />
                                            <img src="../assets/img/delete.png" @click="deleteQuestion('stress', question.id)" style="max-width:30px" class="ml-3" /> <span class="text-danger" @click="deleteQuestion('stress', question.id)">Delete question</span>
                                        </div>
                                    </CCard>
                                </div>
                                <div class="ml-3">
                                    <CButton type="button" class="custom-border-purple-928AFD font-color-615FCD ml-3" style="border-radius:5px" @click="addQuestion('stress')">Add Question</CButton>
                                </div>
                                <div class="text-center">
                                    <CAlert color="danger" v-if="ErrorOtherMax === true" class="mt-2">{{ ErrorMessageOtherMax }}</CAlert>
                                    <CButton type="button" class="custom-border-purple text-white ml-3 b-20" @click="nextTabOther('stress')"><span class="ml-3 mr-3">Next</span></CButton>
                                </div>
                            </div>

                            <div v-if="activeTab === 'assessment'">
                                <span class="custom-light-purple font-color-928AFD mb-3 ml-4">
                                    Assessment Questions List
                                </span>
                                <br /><br />
                                <div v-for="(question,index) in questions.assessment" :key="question.id" class="m-3">
                                    <CCard class="b-20 bg-FAFAFA m-3">
                                
                                    
                                        <div class="m-3">
                                            <h3 class="custom-16px-500 text-left">{{ question.indexQuestion }}</h3>
                                            <CRow>
                                                <CCol sm="8">
                                                    <h4 class="custom-14px-400 font-color-696969">You may clone the question from our question bank or create your own question</h4>
                                                </CCol>
                                                <CCol sm="4">
                                                    <div class="text-right mr-3">
                                                        <label class="font-color-171717 text-right" style="text-align:right" @click="OpenClone('QA', selectedPosition.Code, index)">
                                                            <img src="../assets/img/Plus.png" style="max-width:20px" class="mr-2" @click="OpenClone('QA', selectedPosition.Code, index)"/> Clone
                                                        </label>
                                                        </div>
                                                </CCol>
                                                </CRow>
                                            
                                            
                                            <CInput type="text" v-model="question.answer" id="Q16"/>
                                            <h4 class="custom-14px-400 font-color-696969">Answer</h4>
                                            <CTextarea type="text" rows="3" v-model="question.expectedAnswer" id="Q17"/>
                                            <h4 class="custom-14px-400 font-color-696969">Max Timer</h4>
                                            <v-timepicker
                                            v-model="question.maxTimeLimit"
                                            :options="timer"
                                            format="HH:mm:ss"
                                            :minute-interval="1"
                                            placeholder="Insert Duration"
                                            @input="formatTimerAddMax(item)"
                                            >
                                            </v-timepicker>
                                            <br /><br />
                                            <img src="../assets/img/delete.png" @click="deleteQuestion('assessment', question.id)" style="max-width:30px" class="ml-3" /> <span class="text-danger" @click="deleteQuestion('assessment', question.id)">Delete question</span>
                                        </div>

                                    </CCard>
                                </div>
                                <div class="ml-3">
                                    <CButton type="button" class="custom-border-purple-928AFD font-color-615FCD ml-3" style="border-radius:5px" @click="addQuestion('assessment')">Add Question</CButton>
                                </div>
                                <div class="text-center">
                                    <CAlert color="danger" v-if="ErrorOtherMax === true" class="mt-2">{{ ErrorMessageOtherMax }}</CAlert>
                                    <CButton type="button" class="custom-border-purple text-white ml-3 b-20" @click="nextTabOther('assessment')"><span class="ml-3 mr-3">Next</span></CButton>
                                </div>
                            </div>
                            <div v-if="activeTab === 'code'">
                                <CRow class="m-2">
                                    <CCol sm="6">
                                        <label class="custom-14px-400 font-color-696969"><strong>Started Date</strong></label>
                                        <CInput type="date" v-model="startDate" id="Q18"/>
                                    </CCol>
                                    <CCol sm="6">
                                        <label class="custom-14px-400 font-color-696969"><strong>Expired Date</strong></label>
                                        <CInput type="date" v-model="endDate" id="Q19"/>
                                    </CCol>
                                    <CCol sm="6">
                                        <label class="custom-14px-400 font-color-696969"><strong>Language</strong></label>
                                        <v-select 
                                            v-model="SelectedLanguage" 
                                            :options="language" 
                                            label="Language"
                                        ></v-select>
                                    </CCol>
                                    <CCol sm="12">
                                        <h4 class="custom-14px-400 font-color-696969 mt-4">Prompt Condition - Please describe what you want the answer focusing about</h4>
                                        <CTextarea type="text" rows="3" v-model="Prompt" />
                                    </CCol>
                                    <CCol sm="12" class="mb-2 mt-3">
                                        <label class="custom-14px-400 font-color-696969"><strong>Select Score Category</strong></label>
                                        <div class="custom-purple-928AFD" @click="OpenListCategory()">
                                            Select Score Category
                                        </div>
                                    </CCol>

                                    <CCol sm="12" class="mb-2 mt-2" v-if="isAllowEVoucher">
                                        <CRow>
                                            <CCol sm="9"> <label class="custom-14px-400 font-color-696969"><strong>Include e-Voucher</strong></label></CCol>
                                            <CCol sm="3">
                                                <div class="text-right">
                                                <CButton @click="OpenVoucher()" class="custom-border-purple-white font-color-928AFD">Include e-Voucher</CButton>
                                            </div>
                                            </CCol>
                                        </CRow>
                                    </CCol>

                                    <CCol sm="10">
                                        <label class="custom-14px-400 font-color-696969"><strong>Allow AI report to be emailed</strong></label>
                                        <label class="custom-14px-400 font-color-696969">The "Allow AI report to be emailed" option enables users to receive 
                                            AI-generated reports directly via email. When a user checks the corresponding checkbox, the system automatically emails the report to the user's registered email address once the report is generated. This feature provides users with the convenience of receiving timely reports without having to manually download or access them from the system.</label>
                                    </CCol>
                                    <CCol sm="2">
                                        <div class="text-right mt-3">
                                            <input type="checkbox" v-model="isAllowAIreportEmail" style="width:30px;height:30px" @change="onCheckboxChange" />
                                            
                                        </div>
                                        
                                    </CCol>


                                    <CCol sm="12" class="mb-2">
                                        <label class="custom-14px-400 font-color-696969 mt-4"><strong>Objective</strong></label>
                                        <CTextarea v-model="Objective" type="text" id="20-1" rows="9"></CTextarea>
                                        
                                    </CCol>
                                    <CCol sm="12" class="mt-2">
                                        <span class="custom-light-purple font-color-928AFD mb-3 mt-3">
                                    Code Copy
                                </span>
                                <br /><br />
                                        <CCard class="b-20 bg-FAFAFA">
                                            <div class="m-3">
                                                <h3 class="custom-16px-500 text-left mb-3 font-color-171717">
                                                    Share Your Company Code
                                                </h3>
                                                <CRow>
                                                    <CCol sm="9">
                                                        <CInput type="text" v-model="CodeAff" id="Q20"/>
                                                    </CCol>
                                                    <CCol sm="3">
                                                        <label class="custom-border-purple p-2 text-white" @click="copyCodeAff">
                                <img src="../assets/img/copy-white.png" style="max-width:15px" class="mr-2" />
                                {{ buttonText }}
                                </label>
                                                            </CCol>

                                                </CRow>
                                                <h3 class="custom-16px-500 text-left mb-3 font-color-171717">How It Works</h3>
                                                <p class="font-color-696969 custom-16px-500 text-left" style="color:#696969">
                                                    <strong class="text-black">1. Share Your Code:</strong> Distribute your unique company code with potential candidates. This code will be used to access the set of customized questions prepared by your
                                                    company.
                                                    <br /> <br />
                                                    <strong class="text-black"> 2. Candidate Access: </strong>When candidates enter your company code during their registration or application process, they will be presented with your company's specific
                                                    questions. This ensures that all candidates are evaluated based on the criteria most relevant to your organization.
                                                    <br /> <br />
                                                    <strong class="text-black">3. Customized Evaluation:</strong> Candidates will answer the customized questions provided by your company. This allows you to assess their suitability more accurately based
                                                    on your tailored requirements.
                                                </p>
                                                <div class="text-center mt-3">
                                                    <CAlert color="danger" v-if="ErrorCode === true" class="mt-2">{{ MessageError }}</CAlert>
                                                    <label class="custom-border-purple p-2 mr-5 pl-2 pr-2 text-white" @click="SubmitCode">Publish</label>
                                                </div>

                                            </div>

                                        </CCard>

                                    </CCol>

                                </CRow>

                            </div>
                            </div>
                        </CTab>
                    </CTabs>
                </div>
            </CCard>
        <br /><br /><br />
        </CCol>

        <div v-if="isPopupDelete" class="popup-all backdrop-all">
                <div class="popup-all1">
                    <!-- Popup content -->
                    <div class="text-center">
                        <img style="max-width: 100px" src="../assets/img/Ellipsedelete.png" />
                        <h3 class="custom-18px text-center mt-3">
                            Are you sure want to delete <br /> {{ sessionInterview }} ?
                        </h3>
                        <div class="mt-4">
                            <label class="custom-grey-radius ml-2 font-color-171717 mr-4" @click="DeleteSession(sessionDelete)" style="width:100px">Yes</label>
                            <label class="custom-border-purple p-2 text-center mr-2" @click="CloseDelete()" style="width:100px">Cancel</label>
                        </div>
                    </div>
    
                </div>
            </div>

        <div v-if="isPopupSuccess" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <img style="max-width: 300px" src="../assets/img/successPopup.png" />
                    <h3 class="custom-28px-500 font-color-171717 text-center mt-3">
                        Save Successfully
                    </h3>
                    <CButton class="custom-border-purple mt-4 text-white" @click="closeSuccess" style="width:100px"><span class="ml-2 mr-2">OK</span></CButton>
                </div>
            </div>
        </div>
        <div v-if="isPopupSuccessCode" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <img style="max-width: 300px" src="../assets/img/successPopup.png" />
                    <h3 class="custom-28px-500 font-color-171717 text-center mt-3">
                        You may share the code with your candidates for them to take the interview within the time frame you set up.
                    </h3>
                    <CButton class="custom-border-purple mt-4 text-white" @click="closeSuccessCode" style="width:100px"><span class="ml-2 mr-2">OK</span></CButton>
                </div>
            </div>
        </div>
        <div v-if="isPopupClone" class="popup-all backdrop-all">
        <div class="popup-all1">
            <div class="text-right">
                <img src="../assets/img/close.png" style="max-width:50px;" @click="closePopup1" />
            </div>
            <div class="custom-scroll">
                <h2 class="custom-20px-600">Cloned Existing Questions</h2>

                <div v-if="cloneData[activeTab].cloneQuestion.length">
                    <h4 class="custom-14px-400 font-color-696969">Question</h4>
                    <v-select v-model="selectedCloneQuestion" :options="cloneData[activeTab].cloneQuestion.map(q => q.Question)" @change="selectCloneQuestion"></v-select>


                    <h4 class="custom-14px-400 font-color-696969 mt-4">Expectation Answer</h4>
                    <CTextarea row="9" v-model="selectedCloneQuestionText"></CTextarea>

                    <CButton type="button" @click="closePopup" class="custom-border-purple text-white" block>Clone</CButton>
                </div>
            </div>
        </div>
    </div>

        <div v-if="isPopupSuccessPosition" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <img style="max-width: 300px" src="../assets/img/successPopup.png" />
                    <h3 class="custom-24px-500 font-color-171717 text-center mt-3">
                        Save Successfully
                      
                    </h3>
                    <h4 class="custom-18px-500 font-color-171717 text-center"> Please select your new position on the dropdown custom field of interview.</h4>
                    <CButton class="custom-border-purple mt-4 text-white" @click="closeSuccessPosition" style="width:100px"><span class="ml-2 mr-2">OK</span></CButton>
                </div>
            </div>
        </div>

    
        
        <div v-if="isPopupCloneCode" class="popup-all backdrop-all">
            <div class="popup-all1">
                <div class="text-right">
                    <img src="../assets/img/close.png" style="max-width:50px;" @click="closePopupCode" />
                </div>
                <div class="custom-scroll">
                    <h2 class="custom-20px-600">Cloned Existing Questions</h2>

                    <div v-if="cloneDataCode[activeTabCode].cloneQuestion.length">
                        <h4 class="custom-14px-400 font-color-696969">Question</h4>
                        <v-select v-model="selectedCloneQuestionCode" :options="cloneDataCode[activeTabCode].cloneQuestion.map(q => q.Question)" @change="selectCloneQuestionCode"></v-select>


                        <h4 class="custom-14px-400 font-color-696969 mt-4">Expectation Answer</h4>
                        <CTextarea row="9" v-model="selectedCloneQuestionTextCode"></CTextarea>

                        <CButton type="button" @click="cloneQuestionEdit" class="custom-border-purple text-white" block>Clone</CButton>
                    </div>
                </div>
            </div>

        
        </div>
        <div v-if="isPopupCategory" class="popup-all backdrop-all">
            <div class="popup-all2">
                <CRow class="p-0 mb-0">
                    <CCol sm="11"><label class="custom-20px-600 font-color-171717 mb-0">Select Score Category</label></CCol>
                    <CCol sm="1"> <img src="../assets/img/close.png" style="max-width:50px;text-align:right" @click="closePopupCategory" /></CCol>
                </CRow>
                <h3 class="custom-16px-600 mb-0">Select the Required Score Category</h3>
                <p class="custom-14px-400 mb-0">Drag and drop the available categories into your selected categories to customize your scoring system.</p>
                <div class="custom-scroll-code">
            
                <CCol sm="12" class="p-0 d-sm-down-none">
                    <CRow>
                        <CCol sm="5" class="custom-top-left-radius-purple">
                            <div class="text-center">
                                <h3 class="custom-14px-600 text-white">Available Category</h3>
                            </div>
                        
                        </CCol>
                        <CCol sm="1">
                        
                        </CCol>
                        <CCol sm="5" class="custom-top-right-radius-purple">
                            <h3 class="custom-14px-600 text-white">Your Category</h3>
                        </CCol>
                    </CRow>
                </CCol>

                <CCol sm="12" class="p-2 d-md-none">
                    <div class="row">
                        <div style="width:40%" class="custom-top-left-radius-purple">
                            <div class="text-center">
                                <h3 class="custom-14px-600 text-white">Available Category</h3>
                            </div>
                        
                        </div>
                        <div style="width:15%">
                        
                        </div>
                        <div style="width:45%" class="custom-top-right-radius-purple">
                            <h3 class="custom-14px-600 text-white">Your Category</h3>
                        </div>
                    </div>
                </CCol>
                <CCol sm="12" class="d-sm-down-none">
                    <CRow>
                        <CCol sm="5" style="border-right:1px solid #ccc" class="p-0">
                            <draggable
                                v-model="category"
                                group="categories"
                                @end="onDragEnd"
                                class="draggable-list"
                                item-class="draggable-item p-0"
                            >
                                <div v-for="item in category" :key="item.Id" class="text-center" @click="toggleSelectionAdd(item, 'category')">
                                    <div :class="{'selected': selectedItemsAdd.category.includes(item)}">
                                        {{ item.Category }}
                                        <hr />
                                    </div>
                                </div>

                            </draggable>
                        </CCol>
                        <CCol sm="1">
                            <div class="fixed-buttons">
                                <CButton type="button" @click="moveSelectedAdd('category', 'category2')" class="btn" @touchstart.stop="moveSelectedAdd('category', 'category2')">>></CButton>
                                <CButton type="button" @click="moveSelectedAdd('category2', 'category')" class="btn" @touchstart.stop="moveSelectedAdd('category2', 'category')"><<</CButton>
                            </div> 
                        </CCol>
                        <CCol sm="5" class="p-0" style="border-left:1px solid #ccc">
                            <draggable
                                v-model="category2"
                                group="categories"
                                @end="onDragEnd"
                                class="draggable-list p-0"
                                item-class="draggable-item"
                            >
                                <div v-for="item in category2" :key="item.Id" class="text-center" @click="toggleSelectionAdd(item, 'category2')" @touchstart.stop="toggleSelectionAdd(item, 'category2')">
                                    <div :class="{'selected': selectedItemsAdd.category2.includes(item)}">
                                        {{ item.Category }}
                                        <hr />
                                    </div>
                                </div>
                            </draggable>
                        </CCol>
                    </CRow>
                </CCol>

                <div class="p-2 d-md-none d-lg-none">
                    <div class="row">
                        <div style="border-right:1px solid #ccc;width:40%" class="p-2">
                            <draggable
                                v-model="category"
                                group="categories"
                                @end="onDragEnd"
                                class="draggable-list"
                                item-class="draggable-item p-0"
                            >
                                <div v-for="item in category" :key="item.Id" class="text-center" @click="toggleSelectionAdd(item, 'category')" @touchstart.stop="toggleSelectionAdd(item, 'category')">
                                    <div :class="{'selected': selectedItemsAdd.category.includes(item)}">
                                        {{ item.Category }}
                                        <hr />
                                    </div>
                                </div>
                            </draggable>
                        </div>
                        <div style="width:15%">
                            <div class="fixed-buttons">
                                <CButton type="button" @click="moveSelectedAdd('category', 'category2')" class="btn" @touchstart.stop="moveSelectedAdd('category', 'category2')">>></CButton>
                                <CButton type="button" @click="moveSelectedAdd('category2', 'category')" class="btn" @touchstart.stop="moveSelectedAdd('category2', 'category')"><<</CButton>
                            </div> 
                        </div>
                        <div class="p-2" style="border-left:1px solid #ccc;width:45%">
                            <draggable
                                v-model="category2"
                                group="categories"
                                @end="onDragEnd"
                                class="draggable-list p-0"
                                item-class="draggable-item"
                            >
                
                                <div v-for="item in category2" :key="item.Id" class="text-center" @click="toggleSelectionAdd(item, 'category2')">
                                    <div :class="{'selected': selectedItemsAdd.category2.includes(item)}">
                                        {{ item.Category }}
                                        <hr />
                                    </div>
                                </div>
                            </draggable>
                        </div>
                    </div>
                </div>
            </div>
            <CCol sm="12">
                <div class="text-center mt-1">
                    <CButton @click="submitData" class="custom-border-purple p-20 b-20 text-white">Save Changes</CButton>
                </div>
            </CCol>
        </div>
    </div>


    <div v-if="isPopupEditCategory" class="popup-all backdrop-all">
            <div class="popup-all2">
                <CRow class="p-0 mb-0">
                        <CCol sm="11"><label class="custom-20px-600 font-color-171717 mb-0">Select Score Category</label></CCol>
                        <CCol sm="1"> <img src="../assets/img/close.png" style="max-width:50px;text-align:right" @click="closePopup2" /></CCol>
                </CRow>
                    <h3 class="custom-16px-600 mb-0">Select the Required Score Category</h3>
                    <p class="custom-14px-400 mb-0">Drag and drop the available categories into your selected categories to customize your scoring system.</p>
                    <div class="custom-scroll-code">
                 
                <CCol sm="12" class="p-0 d-sm-down-none">
                    <CRow>
                <CCol sm="5" class="custom-top-left-radius-purple">
                    <div class="text-center">
                        <h3 class="custom-14px-600 text-white">Available Category</h3>
                    </div>
                   
                </CCol>
                <CCol sm="1">
                </CCol>
                <CCol sm="5" class="custom-top-right-radius-purple">
                    <h3 class="custom-14px-600 text-white">Your Category</h3>
                </CCol>
                </CRow>
                </CCol>

                <CCol sm="12" class="p-2 d-md-none">
                    <div class="row">
                        <div style="width:40%" class="custom-top-left-radius-purple">
                            <div class="text-center">
                                <h3 class="custom-14px-600 text-white">Available Category</h3>
                            </div>
                        </div>
                        <div style="width:15%">
                        
                        </div>
                        <div style="width:45%" class="custom-top-right-radius-purple">
                            <h3 class="custom-14px-600 text-white">Your Category</h3>
                        </div>
                    </div>
                </CCol>

            
                <CCol sm="12" class="d-sm-down-none">
                    <CRow>
                    <CCol sm="12" md="5" lg="5" style="border-right:1px solid #ccc" class="p-0">
                        <draggable
                            v-model="category"
                            group="categories"
                            @end="onDragEnd"
                            class="draggable-list p-0"
                            item-class="draggable-item p-0"
                        >
                            <div v-for="item in category" :key="item.Id" class="text-center" @click="toggleSelection(item, 'category')">
                                <div :class="{'selected': selectedItems.category.includes(item)}">
                                    {{ item.Category }}
                                    <hr />
                                </div>
                            </div>
                        </draggable>
                    </CCol>

                    <CCol sm="12" md="1" lg="1">
                        <div class="fixed-buttons">
                            <CButton type="button" @click="moveSelected('category', 'categoryList2')" class="btn">>></CButton>
                            <CButton type="button" @click="moveSelected('categoryList2', 'category')" class="btn"><<</CButton>
                        </div>

                        
                    </CCol>

                    <CCol sm="12" md="5" lg="5" class="p-0" style="border-left:1px solid #ccc">
                        <draggable
                            v-model="categoryList2"
                            group="categories"
                            @end="onDragEnd"
                            class="draggable-list p-0"
                            item-class="draggable-item"
                        >
                            <div v-for="item in categoryList2" :key="item.Id" class="text-center" @click="toggleSelection(item, 'categoryList2')">
                                <div :class="{'selected': selectedItems.categoryList2.includes(item)}">
                                    {{ item.Category }}
                                    <hr />
                                </div>
                            </div>
                            
                        </draggable>
                    </CCol>
                    </CRow>
                </CCol>

                <div class="p-2 d-md-none d-lg-none">
                    <div class="row">
                        <div style="border-right:1px solid #ccc;width:40%" class="p-2">
                        <draggable
                            v-model="category"
                            group="categories"
                            @end="onDragEnd"
                            class="draggable-list p-2"
                            item-class="draggable-item p-0"
                        >
                            <div v-for="item in category" :key="item.Id" class="text-center" @click.stop="toggleSelection(item, 'category')" @touchstart.stop="toggleSelection(item, 'category')">
                                <div :class="{'selected': selectedItems.category.includes(item)}">
                                    {{ item.Category }}
                                    <hr />
                                </div>
                            </div>
                        </draggable>
                    </div>

                    <div style="width:15%">
                        <div class="fixed-buttons">
                            <CButton type="button" @click="moveSelected('category', 'categoryList2')" class="btn" @touchstart.stop="moveSelected('category', 'categoryList2')">>></CButton>
                            <CButton type="button" @click="moveSelected('categoryList2', 'category')" class="btn" @touchstart.stop="moveSelected('categoryList2', 'category')"><<</CButton>
                        </div>

                    
                        
                    </div>

                    <div class="p-2" style="border-left:1px solid #ccc;width:45%">
                        <draggable
                            v-model="categoryList2"
                            group="categories"
                            @end="onDragEnd"
                            class="draggable-list p-2"
                            item-class="draggable-item"
                        >
                            <div v-for="item in categoryList2" :key="item.Id" class="text-center" @click="toggleSelection(item, 'categoryList2')" @touchstart.stop="toggleSelection(item, 'categoryList2')">
                                <div :class="{'selected': selectedItems.categoryList2.includes(item)}">
                                    {{ item.Category }}
                                    <hr />
                                </div>
                            </div>
                            
                        </draggable>
                    </div>
                    </div>
                    </div>

            </div>
            <CCol sm="12">
                <div class="text-center mt-1"> 
                    <CButton @click="UpdateCategory" class="custom-border-purple p-20 b-20 text-white">Save Changes</CButton>
                </div>
            </CCol>
        </div>
    </div>
    <div v-if="isPopupVoucher" class="popup-all backdrop-all">
        <div class="popup-all2">
            <CRow>
                <CCol sm="11"><h3 class="custom-20px-600">Include e-voucher</h3></CCol>
                <CCol sm="1"> <img src="../assets/img/close.png" style="max-width:50px;" @click="closePopupVoucher" /></CCol>
            </CRow>

            <CCard style="border:1px dashed #928AFD">
                <div class="text-center m-5">  <label class="text-center m-0 font-inter">
                    <img src="../assets/img/uploadpicture.png" 
                    class="ShowImg"
                    style="max-width:50px; cursor:pointer" 
                    @change="onFileChangeThumbnail" />

                    <input type="file" 
                        id="thumbnail" 
                        ref="mythumbnail" 
                        style="display:none;" 
                        @change="onFileChangeThumbnail" /><br />
                    
                    <span class="font-color-6941C6">Upload a picture</span> <span class="font-color-696969"><br />
                    </span></label>
                    <div id="preview">
                        <img style="max-width: 100%" v-if="urlThumbnail" :src="urlThumbnail" class="border-16px"/>
                    </div>
                    </div>
            </CCard>
            <CRow>
                <CCol sm="12">
                    <h3 class="custom-12px-400">Voucher Name</h3>
                    <CInput type="text" v-model="VoucherName" placeholder="eg. Campaign 2024"/>
                </CCol>
                <CCol sm="6">
                    <CRow>
                        <CCol sm="6">  <h3 class="custom-12px-400">Voucher Code</h3></CCol>
                        <CCol sm="6">  <img src="../assets/img/info-circle.png" width="20px" v-c-popover="{   header: 'Voucher Code Info',
                        content: 'If you have selected Multiple Redeem,please enter the code in this format: YM1121.If you have not selected Multiple Redeem, add a prefix (e.g., YM). The system will automatically generate the voucher number once it is activated (e.g., YM1121).'
                        }"/></CCol>
                    </CRow> 
                    <CInput type="text" v-model="VoucherCode" @input="checkVoucherCode" placeholder="YMR"/>
                    <!-- Error message display -->
                    <span v-if="voucherCodeExists" class="text-danger">The voucher code you entered already exists. Please create a new code.</span>
                </CCol>
                <CCol sm="6">
                    <h3 class="custom-12px-400">Valid Untill</h3>
                    <div class="input-wrapper">
                        <!-- The input field -->
                        <CInput type="date" v-model="ValidUntil"/>
                        <!-- The icon image, positioned inside the input on the right -->
                    </div>
                </CCol>
            </CRow>
            <CRow>
                <CCol sm="11"><h3 class="custom-12px-400">Multiple Redeem Voucher</h3></CCol>
                <CCol sm="1"> <input type="checkbox" v-model="MultipleClaim" /></CCol>
            </CRow>
            <CRow>
                <CCol sm="11"><h3 class="custom-12px-400">Approve Password</h3></CCol>
                <CCol sm="1"> <input type="checkbox" v-model="ApprovalPassword" /></CCol>

                <CCol sm="12" v-if="ApprovalPassword">
                    <CInput type="text" v-model="key" placeholder="Enter approval password" />
                </CCol>
            </CRow>
            <CRow>
                <CCol sm="11"><h3 class="custom-12px-400">Show Voucher</h3></CCol>
                <CCol sm="1"> <input type="checkbox" v-model="ShowVoucher" /></CCol>
            </CRow>
            <h3 class="custom-12px-400">Redeem Location</h3>
            <CInput type="text" v-model="location" placeholder="eg. Cheras,Klang,Kajang,Subang Jaya"/>

            <h3 class="custom-12px-400">Voucher Amount</h3>
            <CInput type="text" v-model="VoucherAmount" placeholder="eg. Offer value eg By 1 free 1 or 30% off for next purchase"/>

            <h3 class="custom-12px-400">Limit Voucher</h3>
            <CInput type="text" v-model="limit" placeholder="eg. 10"/>
            
            <h3 class="custom-12px-400">Terms and Condition</h3>
            <tinymce
                id="d2"
                placeholder="Terms and Condition"
                class="mb-2"
                v-model="TermCondition"
            ></tinymce>
            <CRow class="mt-5">
                <CCol sm="6">
                    <div class="text-right">
                        <CButton class="p-2 text-center mr-2 text-danger" block @click="closePopupVoucher">Cancel</CButton>
                    </div>
                </CCol>
                <CCol sm="6">
                    <CButton class="custom-border-purple p-2 mr-2 text-white" block @click="SubmitVoucher">Create Voucher</CButton>
                </CCol>
            </CRow>
        </div>
    </div>

    <div v-if="isPopupEditVoucher" class="popup-all backdrop-all">
    <div class="popup-all2">
        <CRow>
            <CCol sm="11"><h3 class="custom-20px-600">Include e-voucher</h3></CCol>
            <CCol sm="1"> <img src="../assets/img/close.png" style="max-width:50px;" @click="closePopupEditVoucher" /></CCol>
        </CRow>
        <CCard style="border:1px dashed #928AFD">
            <div class="text-center m-5">  
                <label class="text-center m-0 font-inter">
                    <img src="../assets/img/uploadpicture.png" 
                    class="ShowImg"
                    style="max-width:50px; cursor:pointer" 
                    @change="onFileChangeThumbnailEdit" />
                    <input type="file" 
                        id="editthumbnail" 
                        ref="editmythumbnail" 
                        style="display:none;" 
                        @change="onFileChangeThumbnailEdit" /><br /><br />

                        <div id="preview">
                            <img style="max-width: 100%" v-if="urlThumbnailEdit" :src="urlThumbnailEdit" class="border-16px"/>
                        </div>
                        <div v-if="hideImg">
                            <img v-if="filePathVoucher != null" :src="filePathVoucher" style="max-width: 100%;" class="border-16px"/>
                            <img v-else src="../assets/img/uploadpicture.png" class="border-16px"/>
                        </div>
                </label>
            </div>
        </CCard>
        <CRow>
            <CCol sm="12">
                <h3 class="custom-12px-400">Voucher Name</h3>
                <CInput type="text" v-model="VoucherNames"/>
            </CCol>
            <CCol sm="6">
                <h3 class="custom-12px-400">Voucher Code</h3>                               
                <CInput type="text" v-model="VoucherCodes"/>
            </CCol>
            <CCol sm="6">
                <h3 class="custom-12px-400">Valid Untill</h3>
                <div class="input-wrapper">
                    <CInput type="date" v-model="ValidUntils"/>
                </div>
            </CCol>
        </CRow>
        <CRow>
            <CCol sm="10"><h3 class="custom-12px-400">Multiple Redeem Voucher</h3></CCol>
            <CCol sm="2"> <input type="checkbox" v-model="MultipleVouchers" /></CCol>
        </CRow>
        <CRow>
            <CCol sm="10"><h3 class="custom-12px-400">Approve Password</h3></CCol>
            <CCol sm="2"> <input type="checkbox" v-model="ApprovalPasswords" /></CCol>

            <CCol sm="12" v-if="ApprovalPasswords">
                <CInput type="text" v-model="keys" placeholder="Enter approval password" />
            </CCol>
        </CRow>
        <CRow>
            <CCol sm="10"><h3 class="custom-12px-400">Show Voucher</h3></CCol>
            <CCol sm="2"> <input type="checkbox" v-model="ShowVouchers" /></CCol>
        </CRow>
        <h3 class="custom-12px-400">Redeem Location</h3>
        <CInput type="text" v-model="locations"/>

        <h3 class="custom-12px-400">Voucher Amount</h3>
        <CInput type="text" v-model="VoucherAmounts"/>

        <h3 class="custom-12px-400">Limit Voucher</h3>
        <CInput type="text" v-model="limits"/>
        <h3 class="custom-12px-400">Terms and Condition</h3>
        <tinymce
            id="d2"
            v-model="TermConditions"
            placeholder="Enter Your Content"
            class="mb-2"
        ></tinymce>
            <CRow class="mt-5">
                <CCol sm="6">
                    <div class="text-right">
                    <CButton class="p-2 text-center mr-2 text-danger" block @click="closePopupEditVoucher">Cancel</CButton>
                    </div>
                </CCol>
                <CCol sm="6">
                    <CButton class="custom-border-purple p-2 mr-2 text-white" block @click="EditVoucher">Save Voucher</CButton>
                </CCol>
            </CRow>
    </div>
</div>

    <div v-if="isShowpopupaddcredit" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <img style="max-width: 100px" src="../assets/img/error.png" />
                    <h3 class="custom-28px-500 font-color-171717 text-center mt-3">
                      Oops!
                    </h3>
                    <h4 class="custom-16px-400 text-center font-color-687588">You have insufficient credit. Please topup credits by subscribe plan.</h4>
                    <CButton class="custom-border-purple mt-4 text-white" @click="closeInfoCredit" style="width:100px">
                        <span class="ml-2 mr-2">OK</span>
                    </CButton>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";
import _ from "lodash";
Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bg.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundMap from "../assets/img/Map.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import backgroundUrNoArrow from "../assets/img/bgline.png";
import { CChartDoughnut } from '@coreui/vue-chartjs'
import { CChartBar } from '@coreui/vue-chartjs'
import ToggleCard from '../components/Toggle.vue';

import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
import draggable from 'vuedraggable';

Vue.component("v-timepicker", VueTimepicker);
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";


export default {

    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        CChartDoughnut,
        CChartBar,
        ToggleCard,
        draggable

    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundMap,
            backgroundUrNoArrow,
            isPopupVisible2: false,
            user: {},
            isPopupVisible3: false,
            filePath: '',

            FullName: '',
            PhoneNumber: '',
            AboutUs: '',
            UserType: '',
            UserId: '',
            Email: '',
            isPopupSuccess: false,
            details: {},
            packages: [],
            password: '',
            currentPassword: '',
            activeTab: 'general',
            selectedPosition: null,
            questions: {
                general: [],
                technical: [],
                behaviour: [],
                stress: [],
                assessment: [],
                code: []
            },
            completedTabs: [],
            CodeAff: '',
            positionOptions: [],
            buttonText: 'Copy',
            QuestionCompanyCode: null,
            startDate: "",
            endDate: "",
            isPopupClone: false,
            cloneQuestion: [],
            questionIndexBeingCloned: null,
            cloneData: {
                general: { questionIndex: null, cloneQuestion: [] },
                technical: { questionIndex: null, cloneQuestion: [] },
                behaviour: { questionIndex: null, cloneQuestion: [] },
                stress: { questionIndex: null, cloneQuestion: [] },
                assessment: { questionIndex: null, cloneQuestion: [] },
                code: { questionIndex: null, cloneQuestion: [] }
            },
            selectedCloneQuestion: null,
            selectedCloneQuestionCode: null,
            selectedCloneQuestionAnswer: '',
            selectedCloneQuestionAnswerCode: '',
            isAddQuestion: false,
            quesList: [],
            fields: [{
                    key: 'Specifications'
                }, {
                    key: 'Amount'
                },
                {
                    key: 'Code'
                }, {
                    key: 'ValidUntill'
                },
                {
                    key: 'Objective'
                }, {
                    key: 'Action'
                },
            ],
            Credit: 0,
            has_lowercase: "",
            has_number: "",
            has_special: "",
            has_uppercase: "",
            has_lowercase: "",

            isPopupDelete: false,
            currentPage: 1,
            itemsPerPage: 10,
            searchQuery: "",
            sessionDelete: "",
            sessionInterview: "",
            ShowList: true,
            isPopupSuccessCode: false,
            quesListCode: [],
            isUpdateQuestion: false,
            activeTabCode: 'QG', // default tab
            isPopupCloneCode: false,
            cloneDataCode: {
                QG: { cloneQuestion: [], questionIndex: null },
                QT: { cloneQuestion: [], questionIndex: null },
                QB: { cloneQuestion: [], questionIndex: null },
                QS: { cloneQuestion: [], questionIndex: null },
                QA: { cloneQuestion: [], questionIndex: null },
                code: { cloneQuestion: [], questionIndex: null }
            },
            idquestion: "",
            jobValue: "",
            jobCode: "",
            jobId: "",
            ErrorGeneral: false,
            ErrorCode: false,
            MessageError: "",
            statusCode: {},
            ErrorEdit: false,
            country: [],
            SelectedCountry: {},
            isPopupCategory: false,
            category: [],
            category2: [],
            categoryList2: [],
            isPopupEditCategory: false,
            idcompany: "",
            selectedItems: {
                category: [], // selected items in the first column
                categoryList2: [] // selected items in the second column
            },
            selectedItemsAdd: {
                category: [], // selected items in the first column
                category2: [] // selected items in the second column
            },
            Objective: "",
            showObjective: '',
            visibleObjectiveId: null,

            errorMessages: {},
            technicalErrorMessages: [],
            behaviourErrorMessages: [],
            stressErrorMessages: [],
            assessementErrorMessages: [],
            timer: {
                format: 'HH:mm:ss',
                minuteInterval: 1,
                placeholder: 'Insert Duration',
                ErrorGeneralMax: false,
                ErrorOtherMax: false,
            },
            isPopupVoucher: false,

            thumbnail: [],
            urlThumbnail: null,

            editthumbnail: [],
            urlThumbnailEdit: null,

            VoucherName: "",
            VoucherCode: "",
            ValidUntil: "",
            TermCondition: "",
            limit: "",
            location: "",
            isPopupEditVoucher: false,
            VoucherAmount: "",
            
            
            VoucherNames: "",
            VoucherCodes: "",
            ValidUntils: "",
            TermConditions: "",
            limits: "",  // Correct casing here
            locations: "",
            VoucherAmounts: "",
            MultipleVouchers: false,
            ApprovePasswords:false,
            keys: "",
            ShowVouchers:false,
            hideImg: true,
            filePathVoucher: '',
            MultipleClaim: false,
            voucherCodeExists: false,
            checking: {},
            ApprovalPassword: false,
            ShowVoucher: false,
            ApprovalPasswords: false,
            windowWidth: window.innerWidth,

            isAllowAIreportEmail: false,
            isShowpopupaddcredit: false,
            languages: [],
            SelectedLanguage: "",
            Prompt: "",

            customPosition: "",
            showCustomInput: false, // Toggle for custom position input
            isPopupSuccessPosition: false,
            ErrorPosition:false,
            features: [],

            SelectedJob: {}
        }
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateWindowWidth);
    },
    watch: {
  jobValue(newVal) {
    console.log("Job selection changed to:", newVal);
  }
},
    async mounted() {
        try {
            const isAuth = await this.UserAuth();
            if (isAuth) {
                this.getFeatures();
                this.GetInfoUser();
                this.GetListPackage();
                this.generateRandomCodeAndNumber();
               // this.getListPosition();
                this.getListInterview();
                this.GetListCountries();
                this.GetListDataEvaluation();
                window.addEventListener('resize', this.updateWindowWidth);
                this.GetListlanguage();
            } else {
                this.GoToLogin();
            }
        } catch (error) {
            this.GoToLogin();
            console.error("Error during authentication:", error);
            // Handle the error here
        }

    },
    computed: {
        selectedCloneQuestionText() {
            if (this.selectedCloneQuestion) {
                const question = this.cloneData[this.activeTab].cloneQuestion.find(q => q.Question === this.selectedCloneQuestion);
                return question ? question.Answer : '';
            }
            return '';
        },
        selectedCloneQuestionTextCode() {
            if (this.selectedCloneQuestionCode) {
                const question = this.cloneDataCode[this.activeTabCode].cloneQuestion.find(q => q.Question === this.selectedCloneQuestionCode);
                return question ? question.Answer : '';
            }
            return '';
        },
        filteredList() {
            const query = (this.searchQuery || '').toLowerCase().trim(); // Ensure searchQuery is a string

            // Debugging line
            console.log(Array.isArray(this.quesList), this.quesList);

            // Check if quesList is an array
            if (!Array.isArray(this.quesList)) {
                return [];
            }

            const filtered = this.quesList.filter(item => {
                const job = item.job || ''; // Ensure item.job is a string
                const code = item.code || '';
                const matchesQuery = query ? job.toLowerCase().includes(query) || code.toLowerCase().includes(query) : true;

                return matchesQuery;
            });

            return filtered;
        },
        buttonQuestion() {
            return this.isAddQuestion ? 'Back to Home' : 'Add Question';
        },


        generalQuestionsCode() {
            return this.quesListCode.filter(item => item.categoryCode === 'QG');
        },
        technicalQuestionsCode() {
            return this.quesListCode.filter(item => item.categoryCode === 'QT');
        },
        behaviourQuestionsCode() {
            return this.quesListCode.filter(item => item.categoryCode === 'QB');
        },
        stressQuestionsCode() {
            return this.quesListCode.filter(item => item.categoryCode === 'QS');
        },
        assessmentQuestionsCode() {
            return this.quesListCode.filter(item => item.categoryCode === 'QA');
        },
        colStyle() {
      return {
        width: this.windowWidth >= 992 ? '80%' : '100%', // 992px is the breakpoint for lg in Bootstrap
        margin: 'auto'
      };
    },
    
    },
    created() {
        // Set default language to English
        this.SelectedLanguage = this.language.find(lang => lang.Language === "English");
    },
    methods: {
        updateWindowWidth() {
            this.windowWidth = window.innerWidth;
        },
        password_check() {
            this.has_number = /\d/.test(this.password);
            this.has_lowercase = /[a-z]/.test(this.password);
            this.has_uppercase = /[A-Z]/.test(this.password);
            this.has_special = /[!@#$%^&*(),.?":{}|<>]/.test(this.password);

            // Debugging logs
            console.log('Password:', this.password);
            console.log('Has number:', this.has_number);
            console.log('Has lowercase:', this.has_lowercase);
            console.log('Has uppercase:', this.has_uppercase);
            console.log('Has special:', this.has_special);
        },
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.info = response.data;
                    console.log("userInfo", this.user);
                    if (response.status == 200 && this.info != null) {
                        this.Name = this.info.name;
                        this.FullName = this.info.name;
                        this.PhoneNumber = this.info.phone;
                        this.Email = this.info.email;
                        this.CountryName = this.info.country;
                        this.UserType = this.info.userType;
                        this.AboutUs = this.info.aboutUs;
                        this.UserId = this.info.id;
                        this.filePath = this.info.filePath;
                        this.Credit = this.info.credit;
                        this.CompanyId = this.info.id;
                        this.GetSuccessPayment(this.UserId);
                        this.SetupSelectedOption(this.CountryName);
                        this.getListPosition(this.CompanyId);
                    } else {
                        console.log(this.info.detail);
                    }

                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        GetListCountries() {
            try {

                return this.$API
                    .get(this.$GetListCountries)
                    .then((response) => {
                        if (response.status == 200) {
                            this.country = response.data;
                        }
                    });
            } catch (error) {
                console.log("eroor1" + response);
            }
        },
        GetListlanguage() {
            try {

                return this.$API
                    .get(this.$GetListLanguages)
                    .then((response) => {
                        if (response.status == 200) {
                            this.language = response.data;
                        }
                    });
            } catch (error) {
                console.log("eroor1" + response);
            }
        },
        GetListDataEvaluation() {
            try {

                return this.$API
                    .get(this.$DataEvaluation)
                    .then((response) => {
                        if (response.status == 200) {
                            this.category = response.data;
                        }
                    });
            } catch (error) {
                console.log("eroor1" + response);
            }
        },
        SetupSelectedOption() {
            console.log("test" + this.CountryName);

            this.SelectedCountry = _.find(this.country, {
                CountryName: this.CountryName,
            });
        },
        triggerFileInput() {
            this.$refs.fileInput.click();
        },
        onFileChange(event) {
            const file = event.target.files[0];
            if (file) {
                this.selectedFile = file; // Store the selected file
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.filePath = e.target.result;
                };
                reader.readAsDataURL(file);

                // Auto-submit the form after file selection
                this.submitProfilePicture();
            }
        },
        async submitProfilePicture() {
            if (this.selectedFile) {
                const formData = new FormData();
                formData.append('file', this.selectedFile);
                formData.append('userId', this.UserId);

                try {
                    const response = await this.$API
                        .post(this.$UploadProfilePhoto, formData, {
                            headers: {
                                'Content-Type': 'multipart/form-data',
                            },
                        });
                    console.log('Image uploaded successfully:', response.data);
                } catch (error) {
                    console.error('Error uploading image:', error);
                }
            } else {
                console.log('No file selected');
            }
        },
        UpdateProfile() {
            const formData = new FormData();

            formData.append("fullName", this.FullName);
            formData.append("phoneNumber", this.PhoneNumber);

            this.$API
                .post(this.$CompanyDetail, formData, { withCredentials: true })
                .then((response) => {
                    if (response.data.status === 400) {
                        this.Loading = false;
                        this.Message = response.data.message;
                        this.Error = true;

                    }
                    if (response.status == 200) {
                        this.UpdateCountry();
                        if (response.data.status !== 400) {
                            this.isPopupSuccess = true;
                            this.GetInfoUser();
                        } else {
                            this.Loading = false;
                            this.Message = response.data.message;
                            this.Error = true;
                        }
                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });

        },
        UpdateCountry() {
            const formData = new FormData();
            formData.append("countryId", this.SelectedCountry.Id);
            this.$API
                .post(this.$UpdateUserCountry, formData, { withCredentials: true })
                .then((response) => {
                    if (response.status == 200) {
                        this.GetInfoUser();
                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        closeSuccess() {
            this.isPopupSuccess = false;
        },
        async GetSuccessPayment() {
            try {
                const response = await this.$API.get(this.$GetSubscription, { withCredentials: true });
                if (response.status === 200) {

                    this.details = response.data;


                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async GetListPackage() {
            try {
                const response = await this.$API.get(this.$GetListPackageCompany);
                if (response.status === 200 && response.data) {
                    this.packages = response.data;
                }
            } catch (error) {
                console.error("Error fetching user info:", error);
            }
        },

        GoToConfirmation(amount, packageId) {
            this.$router.push("ConfirmationPackage?amount=" + amount + "&packageId=" + packageId);
        },
        ChangePassword() {
            const formData = new FormData();

            formData.append("userEmail", this.Email);
            formData.append("newPassword", this.password);

            return this.$API
                .post(this.$ChangePasswordWoCode, formData, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200 && response.data > 0) {
                        this.isPopupSuccess = true;
                    } else {
                        this.ErrorMessage = true;
                    }
                })
                .catch((error) => {
                    if (error.response) {
                        console.log(error.response.data);
                        this.Error = true;
                        this.Message = error;
                        this.Message = "Error";

                        this.ErrorMessage = true;
                    }
                });
        },
        generateRandomCodeAndNumber() {
            // Generate a random code (e.g., alphanumeric code of length 6)
            const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            let code = '';
            for (let i = 0; i < 6; i++) {
                code += characters.charAt(Math.floor(Math.random() * characters.length));
            }

            // Generate a random number (between 0 and 100)
            const number = Math.floor(Math.random() * 101);

            // Update data properties with generated values
            this.randomCode = code;
            this.CodeAff = this.randomCode;
        },
        async getListPosition(CompanyId) {
            try {
                const response = await this.$API.get(this.$GetListPositionCompany + "?companyId=" + CompanyId);
                if (response.status === 200) {
                    this.positionOptions = response.data;
                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        setActiveTab(tab) {
            if (this.isTabEnabled(tab)) {
                this.activeTab = tab;
            }
        },
        isTabEnabled(tab) {
            const tabOrder = ['general', 'technical', 'behaviour', 'stress', 'assessment', 'code'];
            const tabIndex = tabOrder.indexOf(tab);
            if (tabIndex === 0) return true;
            return this.completedTabs.includes(tabOrder[tabIndex - 1]);
        },
        setActiveTabCode(tab) {
            if (this.isTabEnabledCode(tab)) {
                this.activeTabCode = tab;
            }
        },
        isTabEnabledCode(tab) {
            if (tab === 'QG') return true;
            if (tab === 'QT') return this.generalQuestionsCode.every(q => q.question && q.answer);
            if (tab === 'QB') return this.technicalQuestionsCode.every(q => q.question && q.answer);
            if (tab === 'QS') return this.behaviourQuestionsCode.every(q => q.question && q.answer);
            if (tab === 'QA') return this.stressQuestionsCode.every(q => q.question && q.answer);
            if (tab === 'code') return this.assessmentQuestionsCode.every(q => q.question && q.answer);
            return false;
        },
        checkMinimumQuestions(tabName) {
            return this.questions[tabName] && this.questions[tabName].length >= 2;
        },
        async nextTab(currentTab) {
            if (this.validateForm(currentTab)) {
                if (currentTab === 'general' && !this.checkMinimumQuestions('general')) {
                    this.ErrorGeneral = true;
                    return;
                }

                if (!this.completedTabs.includes(currentTab)) {
                    this.completedTabs.push(currentTab);
                }
                await this.submitForm(currentTab);

                if (this.ErrorGeneralMax) {
                    return; // Prevent tab change if there's a max time limit error
                }

                const tabOrder = ['general', 'technical', 'behaviour', 'stress', 'assessment', 'code'];
                const nextTabIndex = tabOrder.indexOf(currentTab) + 1;
                if (nextTabIndex < tabOrder.length) {
                    this.activeTab = tabOrder[nextTabIndex];
                }
            } else {
                alert('Please fill out all required fields.');
            }
        },
        async submitForm(tab) {
            this.ErrorGeneral = false;
            this.ErrorGeneralMax = false;

            const timeStringToSeconds = (timeString) => {
                const [hours, minutes, seconds] = timeString.split(':').map(Number);
                return (hours * 3600) + (minutes * 60) + seconds;
            };

            const maxAllowed = "00:10:00"; // 10 minutes
            const maxTimeInSeconds = timeStringToSeconds(maxAllowed);


            try {
                const categoryCodeMap = {
                    general: 'QG',
                    technical: 'QT',
                    behaviour: 'QB',
                    stress: 'QS',
                    assessment: 'QA',
                    code: 'QC'
                };

                for (let question of this.questions[tab]) {
                    const formattedMaxTimeLimit = typeof question.maxTimeLimit === 'object' && question.maxTimeLimit !== null ?
                        `${question.maxTimeLimit.HH}:${question.maxTimeLimit.mm}:${question.maxTimeLimit.ss}` :
                        question.maxTimeLimit;

                    const maxTimeLimitInSeconds = timeStringToSeconds(formattedMaxTimeLimit);

                    if (maxTimeLimitInSeconds > maxTimeInSeconds) {
                        this.ErrorGeneralMax = true;
                        this.ErrorMessageGeneralMax = `Max time limit for question "${question.question}" exceeds 10 minutes.`;
                        return; // Prevent form submission
                    }
                }

                const qJson = this.questions[tab].map((question, index) => {
                    const formattedMinTimeLimit = "00:01:00"; // Fixed min time
                    const formattedMaxTimeLimit = typeof question.maxTimeLimit === 'object' && question.maxTimeLimit !== null ?
                        `${question.maxTimeLimit.HH}:${question.maxTimeLimit.mm}:${question.maxTimeLimit.ss}` :
                        question.maxTimeLimit;

                    return {
                        id: question.id,
                        categoryCode: categoryCodeMap[tab],
                        question: question.answer,
                        answer: question.expectedAnswer,
                        type: index === 0 ? 'first' : 'other',
                        minTimeLimit: "00:01:00",
                        maxTimeLimit: formattedMaxTimeLimit
                    };
                });

                const formData = new FormData();
                formData.append("questionAnswerJson", JSON.stringify(qJson));
                formData.append("positionCode", this.selectedPosition ?.Code);

                const response = await this.$API.post(this.$InsertQuestionGeneral, formData, {
                    withCredentials: true
                });

                if (response.status === 200) {
                    this.isPopupSuccess = true;
                    this.QuestionCompanyCode = response.data; // Correctly access the response data
                } else {
                    this.Loading = false;
                    this.Error = true;
                }
            } catch (error) {
                this.Loading = false;
                this.Error = true;
            }
        },
        async nextTabOther(currentTab) {
            if (this.validateForm(currentTab)) {
                if (!this.completedTabs.includes(currentTab)) {
                    this.completedTabs.push(currentTab);
                }
                await this.submitFormOther(currentTab);

                if (this.ErrorOtherMax) {
                    return; // Prevent tab change if there's a max time limit error
                }

                const tabOrder = ['general', 'technical', 'behaviour', 'stress', 'assessment', 'code'];
                const nextTabIndex = tabOrder.indexOf(currentTab) + 1;
                if (nextTabIndex < tabOrder.length) {
                    this.activeTab = tabOrder[nextTabIndex];
                }
            } else {
                alert('Please fill out all required fields.');
            }
        },
        async submitFormOther(tab) {
            this.ErrorOtherMax = false;

            const timeStringToSeconds = (timeString) => {
                const [hours, minutes, seconds] = timeString.split(':').map(Number);
                return (hours * 3600) + (minutes * 60) + seconds;
            };

            const maxAllowed = "00:10:00"; // 10 minutes
            const maxTimeInSeconds = timeStringToSeconds(maxAllowed);
            console.log("this.QuestionCompanyCode: " + this.QuestionCompanyCode);
            try {
                const categoryCodeMap = {
                    general: 'QG',
                    technical: 'QT',
                    behaviour: 'QB',
                    stress: 'QS',
                    assessment: 'QA',
                    code: 'QC'
                };

                for (let question of this.questions[tab]) {
                    const formattedMaxTimeLimit = typeof question.maxTimeLimit === 'object' && question.maxTimeLimit !== null ?
                        `${question.maxTimeLimit.HH}:${question.maxTimeLimit.mm}:${question.maxTimeLimit.ss}` :
                        question.maxTimeLimit;

                    const maxTimeLimitInSeconds = timeStringToSeconds(formattedMaxTimeLimit);

                    if (maxTimeLimitInSeconds > maxTimeInSeconds) {
                        this.ErrorGeneral = false;
                        this.ErrorGeneralMax = false;
                        this.ErrorOtherMax = true;
                        this.ErrorMessageOtherMax = `Max time limit exceeds 10 minutes.`;
                        return; // Prevent form submission
                    }
                }

                const qJson = this.questions[tab].map((question, index) => {
                    const formattedMinTimeLimit = "00:01:00"; // Fixed min time
                    const formattedMaxTimeLimit = typeof question.maxTimeLimit === 'object' && question.maxTimeLimit !== null ?
                        `${question.maxTimeLimit.HH}:${question.maxTimeLimit.mm}:${question.maxTimeLimit.ss}` :
                        question.maxTimeLimit;

                    return {
                        id: question.id,
                        categoryCode: categoryCodeMap[tab],
                        question: question.answer,
                        answer: question.expectedAnswer,
                        type: 'other',
                        minTimeLimit: '00:01:00',
                        maxTimeLimit: formattedMaxTimeLimit
                    };
                });


                const formData = new FormData();
                formData.append("questionAnswerJson", JSON.stringify(qJson));
                formData.append("questionCompanyCodeId", this.QuestionCompanyCode);
                formData.append("positionCode", this.selectedPosition ?.Code);

                const response = await this.$API.post(this.$InsertNextQuestion, formData, {
                    withCredentials: true
                });

                if (response.status === 200) {
                    this.isPopupSuccess = true;
                } else {
                    this.Loading = false;
                    this.Error = true;
                }
            } catch (error) {
                this.Loading = false;
                this.Error = true;
            }
        },
        validateForm(tab) {
            const questions = this.questions[tab];
            for (const question of questions) {
                if (!question.answer || !question.expectedAnswer) {
                    return false;
                }
            }
            return true;
        },
        addQuestion(tab) {
            const newQuestionId = this.questions[tab].length + 1;
            this.questions[tab].push({
                id: newQuestionId,
                question: '',
                indexQuestion: `Question ${newQuestionId}`,
                answer: '',
                expectedAnswer: '',
                maxTimeLimit: "00:02:00",
            });
        },
        addQuestionCode(tab) {
            const newQuestionId = this.quesListCode.length + 1;
            const newQuestion = {
                questionId: Date.now(), // Use a unique identifier
                question: '',
                answer: '',
                expectedAnswer: '',
                companyQuestionId: '', // Ensure this matches your actual structure
                indexQuestion: `Question ${newQuestionId}`,
                id: newQuestionId,
                categoryCode: tab,
                minTimeLimit: '00:01:00',
                maxTimeLimit: '00:02:00' // Assuming this is how you categorize questions
            };
            this.quesListCode.push(newQuestion);
            console.log(this.quesListCode); // Debugging line to check the new question is added
        },
        deleteQuestion(tab, questionId) {
            const index = this.questions[tab].findIndex(question => question.id === questionId);
            if (index !== -1) {
                this.questions[tab].splice(index, 1); // Remove question from array
            }
        },
        deleteQuestionList(category, questionId) {
            this.quesListCode = this.quesListCode.filter(item => item.categoryCode !== category || item.questionId !== questionId);
        },
        copyCodeAff() {
            // Create a temporary input element
            const tempInput = document.createElement('input');
            tempInput.value = this.CodeAff;
            document.body.appendChild(tempInput);
            tempInput.select();
            document.execCommand('copy');
            document.body.removeChild(tempInput);

            // Change the button text to "Copied"
            this.buttonText = 'Copied';

            // Optionally, reset the button text after a few seconds
            setTimeout(() => {
                this.buttonText = 'Copy';
            }, 2000);
        },
        GoToLogin() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/Login") {

                this.$router.push({
                    path: '/Login',
                    query: {
                        targetUrl: this.$router.currentRoute.fullPath,
                    }
                })

            }
        },
        async SubmitCode() {
            if (this.startDate === '' || this.endDate === '' || this.CodeAff === '') {
                this.MessageError = 'Error: Please fill all the form.';
                this.ErrorCode = true;
            } else {
                this.ErrorCode = false;
                try {
                    const response = await this.$API.get(this.$CheckQuestionCompanyCode + "?code=" + this.CodeAff);
                    if (response.status === 200) {
                        this.statusCode = response.data;

                        if (this.statusCode === 'Not Valid Code.') {
                            this.MessageError = 'Error: The code already exists';
                            this.ErrorCode = true;
                        } else if (this.statusCode === 'Ok') {
                            this.ConfirmCode();
                        } else {
                            this.MessageError = 'Error: Unexpected response';
                            this.ErrorCode = true;
                            console.error("Unexpected response data:", response.data);
                        }
                    } else {
                        this.MessageError = 'Error: The code already exists';
                        this.ErrorCode = true;
                        console.error("Failed to fetch user information1:", response);
                    }
                } catch (error) {
                    this.MessageError = 'Error: Unexpected response';
                    this.ErrorCode = true;
                    console.error("Error fetching user information2:", error);
                }
            }
        },
        onCheckboxChange(event) {
        console.log('Checkbox changed:', event.target.checked);
    },

        ConfirmCode() {
            const formData = new FormData();
            formData.append("questionCompanyCodeId", this.QuestionCompanyCode);
            formData.append("startDate", this.startDate);
            formData.append("endDate", this.endDate);
            formData.append("code", this.CodeAff);
            formData.append("objective", this.Objective);
            formData.append("isAllowAiReportEmail", this.isAllowAIreportEmail ? 'true' : 'false'); // Explicit conversion
            formData.append("customPrompt", this.Prompt);

            const defaultLanguageId = 1;
  const languageId = this.SelectedLanguage?.Id || defaultLanguageId;
  formData.append("languageId", languageId);


            this.$API
                .post(this.$SubmitCompanyQuestion, formData, {
                    withCredentials: true
                })
                .then((response) => {
                    if (response.data.status === 400) {
                        this.Loading = false;
                        this.Message = response.data.message;
                        this.Error = true;
                    }
                    if (response.status === 200) {
                        this.isPopupSuccessCode = true;
                        this.getListInterview();


                        // window.location.reload();
                    } else {
                        this.Loading = false;
                        this.Error = true;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });

        },
        closeSuccessCode() {
            this.isPopupSuccessCode = false;
            this.toggleHome();
        },
        async OpenClone(type, position, index) {
            this.isPopupClone = true;
            this.cloneData[this.activeTab].questionIndex = index;
            try {
                const response = await this.$API.get(this.$GetQuestionAnswer + "?positionCode=" + position + "&categoryCode=" + type);
                if (response.status === 200) {
                    this.cloneData[this.activeTab].cloneQuestion = response.data;
                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },

        closePopup() {
            const { questionIndex, cloneQuestion } = this.cloneData[this.activeTab];
            if (questionIndex !== null && this.selectedCloneQuestion) {
                const selectedQuestion = cloneQuestion.find(q => q.Question === this.selectedCloneQuestion);
                if (selectedQuestion) {
                    this.questions[this.activeTab][questionIndex].answer = selectedQuestion.Question;
                    this.questions[this.activeTab][questionIndex].expectedAnswer = selectedQuestion.Answer;
                }
            }
            this.isPopupClone = false;
            this.resetCloneData();
        },

        closePopup1() {
            this.isPopupClone = false;
            this.resetCloneData();
        },
        closePopupCategory()
        {
            this.isPopupCategory = false;
        },
        closePopupCode() {
            this.isPopupCloneCode = false;
            this.resetCloneDataCode();
        },
        async selectCloneQuestion() {
            if (this.selectedCloneQuestion) {
                const question = this.cloneData[this.activeTab].cloneQuestion.find(q => q.Question === this.selectedCloneQuestion);
                if (question) {
                    this.selectedCloneQuestionAnswer = question.Answer;
                }
            }
        },
        resetCloneData() {
            this.cloneData[this.activeTab].questionIndex = null;
            this.cloneData[this.activeTab].cloneQuestion = [];
            this.selectedCloneQuestion = null;
            this.selectedCloneQuestionAnswer = '';
        },
        toggleAddQuestion() {
            if(this.Credit > 0)
            {

            this.isUpdateQuestion = false;
            this.isAddQuestion = !this.isAddQuestion;
            this.ShowList = !this.isAddQuestion;
            }
            else
            {
                this.isShowpopupaddcredit = true;
            }

        },
        toggleUpdateQuestion() {
            this.isUpdateQuestion = !this.isUpdateQuestion;
            this.ShowList = !this.isUpdateQuestion;
        },
        toggleHome() {
            this.$router.go(0);
            this.ShowList = !this.isAddQuestion;
        },

        async getListInterview() {
            try {
                const response = await this.$API.get(
                    `${this.$ListCreatedQuestion}`, {
                        withCredentials: true,
                    }
                );
                if (response.status === 200) {
                    this.quesList = response.data;
                } else {

                }
            } catch (error) {}

        },
        OpenDelete(id, job) {
            console.log("id" + id)
            this.sessionDelete = id;
            this.sessionInterview = job;
            this.isPopupDelete = true;
        },
        CloseDelete() {
            this.isPopupDelete = false;
        },
        DeleteSession: function(sessionDelete) {
            const formData = new FormData();

            formData.append("companyQuestionCodeId", sessionDelete);

            return this.$API
                .post(this.$DeleteCompanyQuestionCodeById, formData, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200) {
                        this.Busy = false;
                        this.isPopupDelete = false;
                        this.getListInterview();
                    } else {
                        this.Busy = false;
                        this.$dialog.alert("Error to add").then(function() {});
                    }
                })
                .catch((error) => {
                    this.Busy = false;
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        OpenUpdate(id, job, jobCode) {
            console.log("id" + id)
            this.jobValue = job;
            this.jobCode = jobCode;
            this.jobId = id;
            this.GetListCategoryById(id);
            this.GetListQuesById(id);
            this.idcompany = id;
            //this.isUpdateQuestion = true;
            this.getListPosition(this.idcompany);
            this.SetupSelectedOptionJob(this.jobValue);

            this.isUpdateQuestion = !this.isUpdateQuestion;
            this.ShowList = !this.isUpdateQuestion;
        },
        SetupSelectedOptionJob() {
            console.log("Setting selected job:", this.jobValue, this.positionOptions);

                if (!this.jobValue) {
                    console.warn("Job value is missing.");
                    return;
                }

                // Ensure positionOptions is always an array
                this.SelectedJob = (this.positionOptions || []).find(job => job.Name === this.jobValue);

                if (!this.SelectedJob) {
                    console.warn("Job not found:", this.jobValue);
                } else {
                    console.log("Selected Job Updated:", this.SelectedJob);
                }
        },
        async GetListQuesById(id) {
            try {
                const response = await this.$API.get(
                    `${this.$ListCreatedQuestionByid}?id=${id}`, {
                        withCredentials: true,
                    }
                );
                if (response.status === 200) {
                    this.quesListCode = response.data;
                } else {

                }
            } catch (error) {}

        },
        UpdateQuestion(category, questionId, question, answer, type, index, timermin, timermax) {
            timermin = timermin || "00:01:00"; // default value
    timermax = timermax || "00:02:00"; // default value
console.log("ttm" + timermax);
            this.technicalErrorMessages = [];
            this.behaviourErrorMessages = [];
            this.stressErrorMessages = [];
            this.assessementErrorMessages = [];

            // const timeStringToSeconds = (timeString) => {
            //     const [hours, minutes, seconds] = timeString.split(':').map(Number);
            //     return (hours * 3600) + (minutes * 60) + seconds;
            // };
            const timeStringToSeconds = (timeString) => {
                const [hours, minutes, seconds] = timeString.split(':').map(Number);
                return (hours * 3600) + (minutes * 60) + seconds;
            };

            const minRequired = "00:01:00";
            const maxAllowed = "00:10:00";

            const minTimeInSeconds = timeStringToSeconds(minRequired);
            const maxTimeInSeconds = timeStringToSeconds(maxAllowed);

            if (typeof timermin === 'object' && timermin !== null) {
                timermin = `${timermin.hours}:${timermin.minutes}:${timermin.seconds}`;
            }
            if (typeof timermax === 'object' && timermax !== null) {
                timermax = `${timermax.hours}:${timermax.minutes}:${timermax.seconds}`;
            }

            const timerminInSeconds = timeStringToSeconds(timermin);
            const timermaxInSeconds = timeStringToSeconds(timermax);
            // Validation
            if (timerminInSeconds < minTimeInSeconds) {

                if (category === 'QT') {
                    this.$set(this.technicalErrorMessages, index, "Minimum time must be at least 00:01:00.");
                    return;
                } else if (category === 'QB') {
                    this.$set(this.behaviourErrorMessages, index, "Minimum time must be at least 00:01:00.");
                    return;
                } else if (category === 'QA') {
                    this.$set(this.assessementErrorMessages, index, "Minimum time must be at least 00:01:00.");
                    return;
                }
                 else {
                    this.$set(this.stressErrorMessages, index, "Minimum time must be at least 00:01:00.");
                    return;
                }




                // this.$set(this.errorMessages, index, "Minimum time must be at least 00:01:00.");

            }

            if (timermaxInSeconds > maxTimeInSeconds) {

                if (category === 'QT') {
                    this.$set(this.technicalErrorMessages, index, "Maximum time must not exceed 00:10:00.");
                    // this.$delete(this.technicalErrorMessages, index);
                    return;
                } else if (category === 'QB') {
                    this.$set(this.behaviourErrorMessages, index, "Maximum time must not exceed 00:10:00.");
                    //this.$delete(this.behaviourErrorMessages, index);
                    return;
                } else if (category === 'QA') {
                    this.$set(this.assessementErrorMessages, index, "Maximum time must not exceed 00:10:00.");
                    // this.$delete(this.assessementErrorMessages, index);
                    return;
                } else {
                    this.$set(this.stressErrorMessages, index, "Maximum time must not exceed 00:10:00.");
                    // this.$delete(this.stressErrorMessages, index);
                    return;
                    //return;
                }
                // this.$set(this.errorMessages, index, "Maximum time must not exceed 00:10:00.");
                // return;
            }



            const formData = new FormData();
            formData.append("answer", answer);
            formData.append("type", type);
            formData.append("question", question);
            formData.append("categoryCode", category);
            formData.append("minTimeLimit", "00:01:00");
            formData.append("maxTimeLimit", timermax); // Ensure this is a string
            if (questionId === '') {
                formData.append("companyQuestionId", 0);
            } else {
                formData.append("companyQuestionId", questionId);
            }

            formData.append("id", this.jobId);



            this.$API
                .post(this.$UpdateComUpdateQuestionDetailpanyView, formData, {
                    withCredentials: true
                })
                .then((response) => {
                    if (response.data.status === 400) {
                        this.Loading = false;
                        this.Message = response.data.message;
                        this.Error = true;

                        this.$set(this.errorMessages, index, response.data.message);
                    }
                    if (response.status === 200) {
                        this.isPopupSuccess = true;
                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.$set(this.errorMessages, index, "An unexpected error occurred.");
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                    this.$set(this.errorMessages, index, error.response.data.message);
                });
        },
        formatTimerMin(item) {
            if (typeof item.MinTimeLimit === 'object' && item.MinTimeLimit !== null) {
                item.MinTimeLimit = `${item.MinTimeLimit.hours}:${item.MinTimeLimit.minutes}:${item.MinTimeLimit.seconds}`;
            }
        },
        formatTimerMax(item) {
            if (typeof item.MaxTimeLimit === 'object' && item.MaxTimeLimit !== null) {
                item.MaxTimeLimit = `${item.MaxTimeLimit.hours}:${item.MaxTimeLimit.minutes}:${item.MaxTimeLimit.seconds}`;
            }
        },

        formatTimerAddMin(item) {
            if (typeof item.minTimeLimit === 'object' && item.minTimeLimit !== null) {
                item.minTimeLimit = `${item.minTimeLimit.hours}:${item.minTimeLimit.minutes}:${item.minTimeLimit.seconds}`;
            }
        },
        formatTimerAddMax(item) {
            if (typeof item.maxTimeLimit === 'object' && item.maxTimeLimit !== null) {
                item.maxTimeLimit = `${item.maxTimeLimit.hours}:${item.maxTimeLimit.minutes}:${item.maxTimeLimit.seconds}`;
            }
        },

        UpdateQuestionFirst(category, questionId, question, answer, index, timermin, timermax) {
            const timeStringToSeconds = (timeString) => {
                const [hours, minutes, seconds] = timeString.split(':').map(Number);
                return (hours * 3600) + (minutes * 60) + seconds;
            };

            const minRequired = "00:01:00";
            const maxAllowed = "00:10:00";

            const minTimeInSeconds = timeStringToSeconds(minRequired);
            const maxTimeInSeconds = timeStringToSeconds(maxAllowed);

            if (typeof timermin === 'object' && timermin !== null) {
                timermin = `${timermin.hours}:${timermin.minutes}:${timermin.seconds}`;
            }
            if (typeof timermax === 'object' && timermax !== null) {
                timermax = `${timermax.hours}:${timermax.minutes}:${timermax.seconds}`;
            }

            const timerminInSeconds = timeStringToSeconds(timermin);
            const timermaxInSeconds = timeStringToSeconds(timermax);

            // Validation
            if (timerminInSeconds < minTimeInSeconds) {
                this.$set(this.errorMessages, index, "Minimum time must be at least 00:01:00.");
                return;
            }

            if (timermaxInSeconds > maxTimeInSeconds) {
                this.$set(this.errorMessages, index, "Maximum time must not exceed 00:10:00.");
                return;
            }

            // Clear any previous error messages for this index
            this.$delete(this.errorMessages, index);

            const formData = new FormData();
            formData.append("answer", answer);
            formData.append("type", index === 0 ? 'first' : 'other');
            formData.append("question", question);
            formData.append("categoryCode", category);
            formData.append("companyQuestionId", questionId === '' ? 0 : questionId);
            formData.append("id", this.jobId);
            formData.append("minTimeLimit", "00:01:00");
            formData.append("maxTimeLimit", timermax);

            this.$API.post(this.$UpdateComUpdateQuestionDetailpanyView, formData, {
                withCredentials: true
            }).then((response) => {
                if (response.data.status === 400) {
                    this.Loading = false;
                    this.Message = response.data.message;
                    this.Error = true;
                } else if (response.status === 200) {
                    this.isPopupSuccess = true;
                } else {
                    this.Loading = false;
                    this.Error = true;
                }
            }).catch((error) => {
                this.Loading = false;
                this.Error = true;
                this.Message = error.response.data.message;
            });
        },


        DeleteQuestionCode: function(item) {
            if (!item.Id) {
                // If the item doesn't have an id, it's newly added and can be removed directly from the array
                const index = this.quesListCode.findIndex(q => q.questionId === item.questionId);
                if (index !== -1) {
                    this.quesListCode.splice(index, 1);
                }
            } else {
                const formData = new FormData();

                formData.append("companyQuestionId", item.companyQuestionId);

                return this.$API
                    .post(this.$DeleteCompanyQuestion, formData, {
                        withCredentials: true,
                    })
                    .then((response) => {
                        if (response.status == 200) {
                            this.Busy = false;
                            this.isPopupSuccess = true;
                            this.GetListQuesById(item.Id);

                        } else {
                            this.Busy = false;
                            this.$dialog.alert("Error to add").then(function() {});
                        }
                    })
                    .catch((error) => {
                        this.Busy = false;
                        this.Loading = false;
                        this.Error = true;
                        this.Message = error.response.data.message;
                    });
            }
        },
        updateCheckboxValue(item) {
        console.log("Checkbox updated:", item.isAllowEmailReport);
    },
        UpdateQuestionCode(startdate, enddate, code, id, checked, objective, isAllowAIreport,languageId, prompt) {
            const formData = new FormData();
            console.log("isAllowAIreport passed:", isAllowAIreport); 
            formData.append("id", id);
            formData.append("startdate", startdate);
            formData.append("endDate", enddate);
            formData.append("code", code);
            formData.append("isPublish", checked);
            formData.append("objective", objective);
            formData.append("IsAllowAiReportEmail", isAllowAIreport === true ? "true" : "false");
           formData.append("languageId", languageId);
           formData.append("customPrompt", prompt);
           //need to be comment
           formData.append("field", this.jobValue);

            this.$API
                .post(this.$UpdateDetailQuestionCode, formData, {
                    withCredentials: true
                })
                .then((response) => {
                    if (response.status === 400) {
                        this.ErrorEdit = true;
                        this.Loading = false;
                        this.Message = response.data.message;

                    }
                    if (response.status === 200) {
                        this.isPopupSuccess = true;
                        this.GetListQuesById(id);
                        this.getListInterview();
                    } else {
                        this.Loading = false;
                        this.ErrorEdit = true;
                    }
                })
                .catch((error) => {
                    this.ErrorEdit = true;
                    this.Loading = false;
                    this.Message = error.response.data.message;
                });
        },
        async OpenCloneCode(type, position, index, id) {
            console.log("ind" + index);
            this.idquestion = id;
            this.isPopupCloneCode = true;
            this.cloneDataCode[this.activeTabCode].questionIndex = index;
            try {
                const response = await this.$API.get(this.$GetQuestionAnswer + "?positionCode=" + position + "&categoryCode=" + type);
                if (response.status === 200) {
                    this.cloneDataCode[this.activeTabCode].cloneQuestion = response.data;

                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        cloneQuestionEdit() {
            const { questionIndex, cloneQuestion } = this.cloneDataCode[this.activeTabCode];
            if (questionIndex !== null && this.selectedCloneQuestionCode) {
                const selectedQuestion = cloneQuestion.find(q => q.Question === this.selectedCloneQuestionCode);
                if (selectedQuestion) {
                    // Update the correct questions array based on activeTabCode
                    switch (this.activeTabCode) {
                        case 'QG':
                            this.generalQuestionsCode[questionIndex].question = selectedQuestion.Question;
                            this.generalQuestionsCode[questionIndex].answer = selectedQuestion.Answer;
                            break;
                        case 'QT':
                            this.technicalQuestionsCode[questionIndex].question = selectedQuestion.Question;
                            this.technicalQuestionsCode[questionIndex].answer = selectedQuestion.Answer;
                            break;
                        case 'QB':
                            this.behaviourQuestionsCode[questionIndex].question = selectedQuestion.Question;
                            this.behaviourQuestionsCode[questionIndex].answer = selectedQuestion.Answer;
                            break;
                        case 'QS':
                            this.stressQuestionsCode[questionIndex].question = selectedQuestion.Question;
                            this.stressQuestionsCode[questionIndex].answer = selectedQuestion.Answer;
                            break;
                        case 'QA':
                            this.assessmentQuestionsCode[questionIndex].question = selectedQuestion.Question;
                            this.assessmentQuestionsCode[questionIndex].answer = selectedQuestion.Answer;
                            break;
                            // Add cases for other tabs as needed
                        default:
                            break;
                    }
                }
            }
            this.isPopupCloneCode = false;
            this.resetCloneDataCode();
        },


        selectCloneQuestionCode() {
            if (this.selectedCloneQuestionCode) {
                const question = this.cloneDataCode[this.activeTabCode].cloneQuestion.find(q => q.Question === this.selectedCloneQuestionCode);
                if (question) {
                    this.selectedCloneQuestionAnswerCode = question.Answer;
                }
            }
        },
        resetCloneDataCode() {
            this.cloneDataCode[this.activeTabCode].questionIndex = null;
            this.cloneDataCode[this.activeTabCode].cloneQuestion = [];
            this.selectedCloneQuestionCode = null;
            this.selectedCloneQuestionAnswerCode = '';
        },
        OpenListCategory() {
            this.isPopupCategory = true;
        },
        onDragEnd(evt) {
            // Handle any actions needed after dragging ends
            console.log('Drag ended');
        },
        submitData() {
            // Extract IDs and join them into a comma-separated string
            const categoryIds = this.category2.map(item => item.Id).join(',');
            console.log('Category IDs to submit:', categoryIds);

            const formData = new FormData();
            formData.append("categoryJson", categoryIds); // Append with the name `categoryJson`
            formData.append("id", this.QuestionCompanyCode);

            // Example of sending data using fetch
            this.$API
                .post(this.$EvaluationCategory, formData)
                .then(response => {
                    if (response.status === 200) { // Check if response status is 200
                        this.isPopupSuccess = true;
                        this.isPopupCategory = false;
                        console.log('Success:', response.data);
                    } else {
                        throw new Error('Request failed with status code ' + response.status);
                    }
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        },
        closePopup1() {
            this.isPopupClone = false;
        },
        closePopup2() {
            this.isPopupEditCategory = false;
        },
        OpenUpdateCategory() {
            this.isPopupEditCategory = true;
        },
        async GetListCategoryById(id) {
            try {
                // Make the API call
                const response = await this.$API.get(`${this.$DataEvalutionCompany}?id=${id}`);

                // Check if the response status is 200
                if (response.status === 200) {
                    // Check if the response data is the specific message
                    if (response.data === "No selected category.") {
                        this.categoryList2 = []; // Set to empty array if no categories
                    } else {
                        this.categoryList2 = response.data.map(item => ({
                            Id: item.EvaluationId, // Map to common field name
                            Category: item.Category
                        }));
                    }
                    this.idcompany = id;
                } else {
                    // Handle non-200 response status if needed
                    this.categoryList2 = [];
                    this.idcompany = id;
                }
            } catch (error) {
                // Handle errors
                console.error('Error fetching categories:', error);
                this.categoryList2 = [];
                this.idcompany = id;
            }
        },

        UpdateCategory() {
            // Extract IDs and join them into a comma-separated string
            const categoryIds = this.categoryList2.map(item => item.Id).join(',');
            console.log('Category IDs to submit:', categoryIds);

            const formData = new FormData();
            formData.append("categoryJson", categoryIds); // Append with the name `categoryJson`
            formData.append("id", this.idcompany);

            // Example of sending data using fetch
            this.$API
                .post(this.$EvaluationCategory, formData)
                .then(response => {
                    if (response.status === 200) { // Check if response status is 200
                        this.isPopupSuccess = true;
                        this.isPopupEditCategory = false;
                        console.log('Success:', response.data);
                    } else {
                        throw new Error('Request failed with status code ' + response.status);
                    }
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        },
        onDragEnd(event) {
            // This method is triggered when a drag operation ends
            console.log('Drag end event:', event);

            // Perform additional operations if needed
            // For example, you could log the updated lists or validate data
            console.log('Category list:', this.category);
            console.log('Category2 list:', this.category2);
        },
        toggleSelection(item, list) {
            // Toggle item selection
            const selectedList = this.selectedItems[list];
            const index = selectedList.indexOf(item);

            if (index > -1) {
                // Item is already selected, so remove it
                selectedList.splice(index, 1);
            } else {
                // Item is not selected, so add it
                selectedList.push(item);
            }
        },
        moveSelected(fromList, toList) {
            const from = this[fromList];
            const to = this[toList];
            const selected = this.selectedItems[fromList];

            // Move selected items from the source list to the destination list
            selected.forEach(item => {
                const index = from.indexOf(item);
                if (index > -1) {
                    from.splice(index, 1);
                    to.push(item);
                }
            });

            // Clear selected items after moving
            this.selectedItems[fromList] = [];
        },

        toggleSelectionAdd(item, list) {
            // Toggle item selection
            const selectedList = this.selectedItemsAdd[list];
            const index = selectedList.indexOf(item);

            if (index > -1) {
                // Item is already selected, so remove it
                selectedList.splice(index, 1);
            } else {
                // Item is not selected, so add it
                selectedList.push(item);
            }
        },
        moveSelectedAdd(fromList, toList) {
            const from = this[fromList];
            const to = this[toList];
            const selected = this.selectedItemsAdd[fromList];

            // Move selected items from the source list to the destination list
            selected.forEach(item => {
                const index = from.indexOf(item);
                if (index > -1) {
                    from.splice(index, 1);
                    to.push(item);
                }
            });

            // Clear selected items after moving
            this.selectedItems[fromList] = [];
        },
        toggleObjective(item) {
            // Toggle the visibility of the objective for the clicked item
            if (this.visibleObjectiveId === item.Id) {
                this.visibleObjectiveId = null;
            } else {
                this.visibleObjectiveId = item.Id;
            }
        },
        isObjectiveVisible(item) {
            // Check if the objective for the given item is visible
            return this.visibleObjectiveId === item.Id;
        },

        closePopupVoucher() {
            this.isPopupVoucher = false;
        },
        closePopupEditVoucher() {
            this.isPopupEditVoucher = false;
        },
        OpenVoucher() {
            this.isPopupVoucher = true;
        },
        openEditVoucher(id) {
            this.GetVoucherById(id);
            this.isPopupEditVoucher = true;
        },
       // triggerFileInput() {
       //     this.$refs.mythumbnail.click();
       // },
        onFileChangeThumbnail(event) {
            this.ShowImg = false;
            const file = event.target.files[0];
            if (file) {
                // Handle the file (e.g., upload it or display a preview)
                this.urlThumbnail = URL.createObjectURL(file);
                this.thumbnail = this.$refs.mythumbnail.files;
                console.log(file);
                this.UploadBanner();
            }
        },
        onFileChangeThumbnailEdit(event) {
            this.hideImg = false;
            const file = event.target.files[0];
            if (file) {
                // Handle the file (e.g., upload it or display a preview)
                this.urlThumbnailEdit = URL.createObjectURL(file);
                this.editthumbnail = this.$refs.editmythumbnail.files;
                console.log(file);
                this.UploadEditBanner();
            }
        },
        UploadBanner() {
            const formData = new FormData();
            formData.append("file", this.thumbnail[0]);
            formData.append("id", this.QuestionCompanyCode);


            return this.$API
                .post(this.$UploadBannerVoucher, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((response) => {
                    this.info = response.data;
                    if (response.status == 200) {
                        console.log("Success upload banner");
                    } else console.log("Error Saving");
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        UploadEditBanner() {
            const formData = new FormData();
            formData.append("file", this.editthumbnail[0]);
            formData.append("id", this.QuesId);


            return this.$API
                .post(this.$UploadBannerVoucher, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((response) => {
                    this.info = response.data;
                    if (response.status == 200) {
                        console.log("Success upload banner");
                    } else console.log("Error Saving");
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        SubmitVoucher() {
            if (this.voucherCodeExists) {
                alert("Please provide a valid voucher code.");
                return; // Prevent form submission
            }

            // Additional validation can be added for required fields
            if (!this.VoucherName || !this.VoucherCode || !this.ValidUntil || !this.VoucherAmount) {
                alert("Please fill in all the required fields.");
                return; // Prevent form submission if required fields are missing
            }
            const locationsArray = this.location.split(',').map(loc => ({
                location: loc.trim() // Trim any extra spaces
            }));

          

            const formData = new FormData();
            formData.append("QuestionCompanyCodeId", this.QuestionCompanyCode);
            formData.append("Name", this.VoucherName);
            formData.append("Code", this.VoucherCode);
            formData.append("Amount", this.VoucherAmount);
            formData.append("ValidUntil", this.ValidUntil);
            formData.append("TermCondition", this.TermCondition);
            formData.append("limit", this.limit);

            formData.append("IsShowVoucher", this.ShowVoucher);
            formData.append("MultipleClaim", this.MultipleClaim);

            formData.append("isPasswordCheck", this.ApprovalPassword);
            formData.append("location", JSON.stringify(locationsArray));
           
            if (this.ApprovalPassword && this.key) {
                const passwordArray = this.key.split(',').map(app => ({
                key: app.trim() // Trim any extra spaces
            }));
            formData.append("passKey",  JSON.stringify(passwordArray));
            }
            this.$API
                .post(this.$SubmitVoucher, formData, {
                    withCredentials: true
                })
                .then((response) => {
                    if (response.data.status === 400) {
                        this.Loading = false;
                        this.Message = response.data.message;
                        this.Error = true;
                    }
                    if (response.status === 200) {
                        this.isPopupSuccess = true;
                        this.isPopupVoucher = false;
                        this.getListInterview();


                        // window.location.reload();
                    } else {
                        this.Loading = false;
                        this.Error = true;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        async GetVoucherById(id) {
    try {
        const response = await this.$API.get(`${this.$GetVoucherById}?id=${id}`, {
            withCredentials: true,
        });
        if (response.status === 200 && response.data) {
            const vc = response.data;
            this.VoucherAmounts = vc.Amount;
            this.VoucherCodes = vc.Code;
            this.limits = vc.Limit;
            this.VoucherNames = vc.Name;
            this.TermConditions = vc.TermCondition;
            this.ValidUntils = vc.ValidUntil;
            this.locations = vc.location;
            this.filePathVoucher = vc.filePath;
            this.QuesId = vc.Id;
            this.MultipleVouchers = vc.isMultiple;  // Correctly set the checkbox value
            this.ApprovalPasswords = vc.IsPasswordCheck;  // Correctly set the checkbox value
            this.keys = vc.password;
            this.ShowVouchers = vc.IsShowVoucher;  // Correctly set the checkbox value
        } else {
            console.log("No data found or invalid response.");
        }
    } catch (error) {
        console.error("Error fetching voucher:", error);
    }
    },

    // Method to save voucher data
    EditVoucher() {
        let locationsArray = [];

        if (typeof this.locations === 'string') {
            locationsArray = this.locations.split(',').map(loc => ({
                location: loc.trim() // Trim spaces around each location
            }));
        } else if (Array.isArray(this.locations)) {
            locationsArray = this.locations.map(loc => ({
                location: loc.trim()
            }));
        } else {
            console.error("Invalid type for locations:", typeof this.locations);
        }

      

        const formData = new FormData();
        formData.append("QuestionCompanyCodeId", this.QuesId);
        formData.append("Name", this.VoucherNames);
        formData.append("Code", this.VoucherCodes);
        formData.append("Amount", this.VoucherAmounts);
        formData.append("ValidUntil", this.ValidUntils);
        formData.append("TermCondition", this.TermConditions);
        formData.append("limit", this.limits);
        formData.append("MultipleClaim",this.MultipleVouchers); // Ensure correct value is appended
        formData.append("isPasswordCheck", this.ApprovalPasswords);

        formData.append("IsShowVoucher",this.ShowVouchers); // Ensure correct value is appended
        formData.append("location", JSON.stringify(locationsArray)); // Stringify array for the request

        if (this.ApprovalPasswords && this.keys) {
            let keyArray = [];

if (typeof this.keys === 'string') {
   keyArray = this.keys.split(',').map(loc => ({
        key: loc.trim() // Trim spaces around each location
    }));
} else if (Array.isArray(this.keys)) {
    keyArray = this.keys.map(loc => ({
        key: loc.trim()
    }));
} else {
    console.error("Invalid type for key:", typeof this.keys);
}
              
            formData.append("passKey",  JSON.stringify(keyArray));
            }
        
        // Ensure correct value is appended

        this.$API.post(this.$SubmitVoucher, formData, {
            withCredentials: true
        })
        .then((response) => {
            if (response.status === 200) {
                this.isPopupSuccess = true;
                this.isPopupEditVoucher = false;
                this.getListInterview();
            } else {
                this.Loading = false;
                this.Error = true;
            }
        })
        .catch((error) => {
            this.Loading = false;
            this.Error = true;
            this.Message = error.response.data.message;
        });
    },
    async GetCheckingVoucher(voucherCode) {
  try {
    const response = await this.$API.get(`${this.$CheckExistingVoucherCode}?code=${voucherCode}`);
    if (response.status === 200 && response.data) {
      // Assuming response.data.message contains the API message (e.g., "Not valid Code")
      if (response.data === "Not valid Code.") {
        this.voucherCodeExists = true; // Set the error flag
      } else {
        this.voucherCodeExists = false; // Reset the flag if the code is valid
      }
    }
  } catch (error) {
    console.error("Error checking voucher code:", error);
    this.voucherCodeExists = true; // Set error flag in case of network issues
  }
},
async checkVoucherCode() {
    if (this.VoucherCode) {
      // Call the API to validate the voucher code
      await this.GetCheckingVoucher(this.VoucherCode);
    }
  },
  GoToPlanCompany()
  {
    this.$router.push("PlanCompany");
  },
  closeInfoCredit()
  {
    this.isShowpopupaddcredit = false;
  },
  toggleCustomPositionInput() {
      this.showCustomInput = !this.showCustomInput;
      this.customPosition = ""; // Reset input when toggling
    },
    AddCustomPosition() {
        const formData = new FormData();
        formData.append("name", this.customPosition);

        this.$API
            .post(this.$InsertNewDataPosition, formData, {
            withCredentials: true,
            })
            .then((response) => {
            if (response.status === 200) {
                this.isPopupSuccessPosition = true;
                this.getListPosition(this.CompanyId);
            } else {
                // Handle unexpected responses
                console.error("Unexpected response", response);
                this.Loading = false;
                this.Error = true;
            }
            })
            .catch((error) => {
            if (error.response && error.response.status === 400) {
                // Custom error message from the backend
                this.Message = error.response.data.message || "Position already exists.";
                this.ErrorPosition = true;
            } else {
                // Handle other errors
                console.error("Unexpected error", error);
                this.Message = "Position already exists.";
                this.ErrorPosition = true;
            }
            this.Loading = false;
            this.Error = true;
            });
        },
        closeSuccessPosition() {
        console.log("Closing popup");
        this.isPopupSuccessPosition = false;
        },
        async getFeatures() {
            try {
                const response = await this.$API.get(this.$GetFeatures, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.features = response.data;
                } else {
                    console.error(`Unexpected response status: ${response.status}`);
                }
            } catch (error) {
                console.error('Error fetching features:', error);
            }
        },






    }

};
</script>

<style scoped>
.tabs {
    /* display: flex; */
    justify-content: start;
    margin-bottom: 10px;
    color: #696969;
}

.tabs span {
    padding: 10px 5px;
    cursor: pointer;
    background: none;
    border: none;
    outline: none;
    color: rgba(105, 105, 105, 0.50);
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 25px;
    /* 156.25% */
}

.tabs span.active {
    font-weight: bold;
    color: #928AFD;
}

.tabs span.disabled {
    pointer-events: none;
    opacity: 0.5;
}

.draggable-list {
    min-height: 100px;
    border-radius: 4px;
}

.draggable-item {
    padding: 10px;
    margin-bottom: 5px;
    border: 1px solid #ddd;
    background: #fff;
    border-radius: 4px;
    user-select: none;
}

.selected {
    background-color: #e0e0e0;
    /* Or any other highlight color */
}
</style>

